import { appraisalMeetingi18n } from './i18n-web-appraisal-steps.en'
import { companySettingsi18n } from './i18n-web-company-settings.en'
import { dashboardsI18n } from './i18n-web-dashboard.en'
import { hrViewi18n } from './i18n-web-hr-view'
import { reportsI18n } from './i18n-web-reports.en'
import { formValidationsI18n } from './i18n-web-validation.en'

const i18nTranslationsWebEn = {
  ...appraisalMeetingi18n,
  ...formValidationsI18n,
  ...dashboardsI18n,
  ...companySettingsi18n,
  ...reportsI18n,
  ...hrViewi18n,
  navigation: {
    dashboard: 'Dashboard',
    profile: 'Profile',
    logout: 'Logout',
    tamtamy: 'TamTamy',
    serviceDesk: 'Service Desk',
    geco: 'Geco',
    meply: 'Meply',
    skillCenter: 'Skill Center',
    tooltip: {
      search: 'Search',
      settings: 'Settings',
      otherApps: 'Other Apps',
      alyssa: 'Alyssa',
    },
    search: {
      placeholder: 'Search employees...',
      startTyping: 'Type in some longer name...',
      noResults: 'No results...',
      loading: 'Loading...',
      recentlyViewed: 'Recently viewed profiles',
      viewAllResults: 'View all results',
    },
  },
  searchResults: {
    numberOfResults: '{{count}} result for: "{{value}}"',
    numberOfResults_plural: '{{count}} results for: "{{value}}"',
    employee: 'Employee',
    level: 'Level',
    bu: 'BU',
    startDate: 'Start date',
    endDate: 'End date',
    actions: 'Actions',
    noResults: 'There are no results for "{{value}}".',
    tryAgain: 'You can try with a new search.',
    searching: 'Searching...',
    noSearchTerm: 'No results',
    company: 'Company',
    status: 'Status',
  },
  auth: {
    login: {
      title: 'Personae 2.0 Login',
      emailPlaceHolder: 'Enter your email address...',
      passwordPlaceHolder: 'Enter your password...',
      loginError: 'Error: Wrong username or password',
    },
    logout: 'logging out ...',
  },
  tooltip: {
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    dismiss: 'Dismiss',
    reactivate: 'Reactivate',
    duplicate: 'Duplicate',
    duplicateAndDismiss: 'Duplicate and dismiss',
    duplicateAndDelete: 'Duplicate and delete',
    add: 'Add',
    confirm: 'Confirm',
    cancel: 'Cancel',
    remove: 'Remove',
    error: 'Error while retrieving data',
  },
  table: {
    actions: 'Actions',
    emptyText: 'Sorry, no data available.',
  },
  page: {
    error: {
      pageUnavailable: {
        title: 'Sorry this page is currently unavailable for you.',
        info: 'Please contact an admin, if you were able to see it in the past.',
        errorHeading: 'Sorry this section is currently unavailable for you.',
        errorCode: 'Error Code: {{errorCode}}',
        noData: "It looks like there's no data to show right now.",
        insufficientRole: 'You do not have the necessary permissions.',
        contactAdmin: 'Please contact an administrator if the issue persists.',
        customMessage: {
          meetingHistory: "It's not possible to view the meetings already held for this employee.",
          kudosCarouselPublic: "It's not possible to view the kudos for this employee.",
          kudosCarouselPrivate: "It's not possible to view your kudos.",
          KudosManagementPage: 'You do not have sufficient roles to view this page.',
        },
      },
      meplyUnavailable: {
        title: 'Sorry Meply is currently unavailable for you.',
      },
      multipleUsers: {
        info: 'Please report the error code 0302 to the Meply support team.',
      },
      unknownUser: {
        info: "You have a valid login, but you aren't registered on Meply yet.",
        info2: 'Please contact HR.',
      },
      btnBack: 'Back to last page',
    },
  },
  user: {
    unknown: {
      name: 'Unknown User',
    },
  },
  loadingAndErrors: {
    loadingPleaseWait: 'Loading ... please wait ...',
  },
  sideNavigation: {
    profile: 'Profile',
    ownGrowth: 'Own growth',
    meetings: 'Meetings',
    kudos: 'Kudos',
    attentionPoints: 'Attention Points',
    rankings: 'Cultivating Talents',
    employees: 'Employees',
    targets: 'Targets',
    pyramids: 'Pyramids',
    scoreGrids: 'Evaluation Grids',
    notes: 'Notes',
    yourCompany: 'Your Company',
    allCompanies: 'All Companies',
    hrSettings: 'Settings',
    hrSupport: 'HR Support',
    dashboard: 'Dashboard',
    globalAdmin: 'Global Admin',
    downloads: 'Downloads',
  },
  dayPicker: {
    short: {
      mon: 'Mon',
      tue: 'Tue',
      wed: 'Wed',
      thu: 'Thu',
      fri: 'Fri',
    },
    long: {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednsday',
      thu: 'Thursday',
      fri: 'Friday',
    },
  },
  scoreGridsView: {
    companyOrCountryCascaderSearchPlaceholder: 'Search company or country…',
    empty: {
      heading: 'You currently have no companies with active employees',
      message: 'As soon as active employees are present, it will be possible to see the Score Grids',
    },
  },
  rankingView: {
    empty: {
      heading: 'You currently have no companies with active employees',
      message: 'As soon as active employees are present, it will be possible to see the Cultivating talents',
    },
    infoBox: {
      employeesHeading: 'Employees',
      performance: {
        heading: 'Performance',
        untagged: 'Untagged',
        minLowTagsPossibleLabel: 'min',
        maxTopTagsPossibleLabel: 'max',
        open: 'Open',
        closed: 'Closed',
        performanceAssignment: 'Performance assignment',
        tooltipOpen:
          "Now it's possible to assign TOP tag. It's mandatory to confirm tags in order to allow appraisal meetings for your company.",
        tooltipClosed: "Once a year it's mandatory to assign and confirm the TOP tag to your team in order to allow appraisal meetings.",
      },
      impactOfLoss: {
        heading: 'Impact of Loss',
        untagged: 'Untagged',
      },
      riskOfLoss: {
        heading: 'Risk of Loss',
        untagged: 'Untagged',
      },
      settings: {
        heading: 'Settings',
      },
    },
    table: {
      ranking: {
        heading: 'Ranking {{year}}',
        rankTooltip: {
          previousCompanyRankText: '{{employeeName}} has another rank in {{year}}',
          previousCompanyRankInfo: '{{rank}} / {{total}} - {{companyName}}',
        },
        previousCompanyRank: '{{rank}} / {{total}}',
      },
      previousRanking: {
        heading: 'Ranking {{year}}',
      },
      assessable: {
        heading: 'Assessable',
        assessableTooltip: 'Assessable',
        notAssessableTooltip: 'Not Assessable',
      },
      employee: {
        heading: 'Employee',
      },
      businessUnit: {
        heading: 'BU',
      },
      evaluation: {
        heading: 'Evaluation',
        tooltip: "Evaluations with an asterisk * were imported but haven't been confirmed in an Appraisal or Appraisal Update yet.",
      },
      performance: {
        heading: 'Performance',
      },
      impactOfLoss: {
        heading: 'Impact of Loss',
      },
      riskOfLoss: {
        heading: 'Risk of Loss',
      },
      actions: {
        heading: 'Actions',
        removeLow: 'Remove Low tag',
        addEntryLevelLow: 'Add Low tag',
        viewTagHistory: 'View tag history',
        viewProfile: 'View profile',
        tagEmployeePerformance: {
          tooltip: 'Performance of {{employee}}',
          title: 'Performance',
          subtitle: 'Of {{employee}}',
          information: {
            speaker: {
              title: 'Speaker',
              description: 'Can be involved in Meetups, Conferences etc.',
            },
            sales: {
              title: 'Sales',
              description:
                'Gains new opportunities, might grow into a client manager position and is really good in customer communication/ management.',
            },
            coach: {
              title: 'Coach',
              description: 'Perfect candidate for the Leadership program.',
            },
            expert: {
              title: 'Expert',
              description:
                'Skilled Senior colleague who could coordinate and empower a single development team. Could be involved in challenging teams, projects and tenders for larger opportunities and important customers',
            },
            untagged: {
              title: 'Untagged',
              description: 'If nothing else fits the employee.',
            },
            low: {
              title: 'Low',
              description:
                'A low performer is an employee whose performance, behaviour or development potential is consistently and significantly below the expectations set for their role, level of experience or peer group.',
            },
            top: {
              title: 'Top',
              description: 'The employee is a top performer.',
            },
          },
          confirmLowTagAssignmentModal: {
            heading: 'Confirm low tag assignment',
            description1: 'Are you sure you want to assign the LOW tag to {{employeeFullName}}?',
            existingFutureChangesForeseenByContract:
              "There are existing changes to {{employeeFirstName}}'s employment agreement that were already planned in the future. The LOW tag can't be assigned. Please, contact HR for further information",
            existingOpenEmploymentChanges:
              "There are pending employment changes scheduled for {{employeeFirstName}}. Are you sure you want to assign the LOW tag? This might affect the contents of {{employeeFirstName}}'s meeting. Please, note that this action can't be reverted once confirmed",
            bonusAfterFirstJanuary:
              "There are some changes to {{employeeFullName}}'s target bonus during the year. Are you sure you want to assign the LOW tag? This might affect {{employeeFirstName}}'s future changes and overwrite them.",
            description1OngoingAppraisal:
              "{{employeeFirstName}} {{employeeLastName}} currently has an ongoing appraisal meeting. Are you sure you want to assign the LOW tag? This might affect {{employeeFirstName}}'s meeting contents.",
            description2: "Please be reminded that this action can't be reverted once confirmed and results in:",
            item1: 'no eligibility for career progression (like raises or promotions)',
            item2: 'no further assignment of monetary targets.',
            description3: "Please be reminded that this action can't be reverted once confirmed.",
          },
          addEntryLevelLowTagAssignmentModal: {
            heading: 'Confirm low tag assignment',
            description1: 'Are you sure you want to assign the LOW tag to {{employeeFullName}}?',
            noExistingFutureChangesForeseenByContract:
              "The LOW tag can't be assigned because there are no planned future changes to {{employeeFirstName}}'s employment agreement. The LOW tag can be assigned by HR only if there is at least one future employment change.",
            existingOpenEmploymentChanges:
              "There are pending employment changes scheduled for {{employeeFirstName}}. Are you sure you want to assign the LOW tag? This might affect the contents of {{employeeFirstName}}'s meeting.",
            description1OngoingAppraisal:
              "{{employeeFirstName}} {{employeeLastName}} currently has an ongoing appraisal meeting. Are you sure you want to assign the LOW tag? This might affect {{employeeFirstName}}'s meeting contents.",
            description2: 'Please be reminded that this action will result in:',
            item1: 'no eligibility for career progression (like raises or promotions)',
            item2: 'no further assignment of monetary targets.',
            loadError: 'Something went wrong while loading the confirmation details.',
            confirmError: 'Something went wrong while assigning the LOW tag.',
          },
          groups: {
            top: 'Top',
            untagged: 'Untagged',
            low: 'Low',
            mainTag: 'Main Tag',
            expertise: 'Expertise',
            maxTopTags: 'You have reached the max number of TOP tags.',
          },
          lowIsDisabled: 'You are not allowed to remove the low tag. Please contact HR if you want to remove it.',
          lowWarning: "Please note you can't remove the low tag after confirming.",
          notifications: {
            update: {
              title: 'Tags updated',
              description: 'Tags successfully updated.',
            },
          },
        },
        tagEmployeeRetention: {
          tooltip: 'Retention of {{employee}}',
          title: 'Retention',
          subtitle: 'Of {{employee}}',
          groups: {
            impact: 'Impact of loss',
            risk: 'Risk of loss',
          },
        },
      },
      disabled: {
        heading: 'The {{year}} Ranking for this company is not open yet',
        headingWithoutYear: 'The Ranking for this company is not open yet',
        info: 'You need to set up reference values before starting tag assignment and ranking for the year {{year}}',
        infoWithoutYear: 'You need to set up reference values before starting tag assignment and ranking',
        btn: 'Enable cultivating talents',
      },
      empty: {
        heading: 'There are no rankable employees in this company and country',
      },
    },
    modalTagHistory: {
      title: 'Tag History',
      subtitle: 'Of {{employee}}',
      table: {
        addedDate: 'Added on',
        removeDate: 'Removed on',
        tag: 'Tag',
        lowRemovalReason: 'Low removal reason',
        by: 'By',
      },
    },
    modalRankingAndTagsConfirmation: {
      header: 'Confirm Ranking and Tags Assignment',
      description:
        'Once you confirm the Performance assignment and the Ranking, the appraisal will be opened. Once you confirm, changes will not be allowed anymore.',
      description2:
        'There is at least one missing position in the ranking due to employees who left the Company. Please, note that all gaps between positions will be automatically filled upon clicking "Confirm".',
      error: 'Error confirming Ranking and Tags',
      confirmationDone: 'Ranking and Tags assignment has been completed',
    },
    modalTopTagConfirmation: {
      header: 'Top tag assignment confirmation',
      description:
        'Once you confirm the TOP tag assignment, the appraisal meetings will be allowed and it won’t be possible to modify your choices anymore.',
      confirmation: 'Do you want to proceed?',
      confirmationDone: 'Top tag assignment has been completed',
      error: 'Error confirming TOP tags',
    },
    messages: {
      confirmationNotDone: 'You did not complete performance assignment.',
      confirmationNotDoneDescription:
        'Please assign and confirm TOP tags in order to allow appraisal meetings. You need to add at least one TOP tag.',
      confirmationDoneDescription: 'The appraisal process is now allowed in your company.',
      performanceAssignmentInProgress: 'Performance assignment is in progress.',
      performanceAssignmentInProgressDescription: 'Performance assignment is currently in progress for this company.',
      assignTagsByPercentage: 'Assign LOW and TOP tags according to min and max percentages',
      assignLowTagsByPercentage: 'Assign LOW tags according to min percentages',
      assignTopTagsByPercentage: 'Assign TOP tags according to max percentages',
    },
    sortByEvaluationButton: 'Rank by Evaluation',
    excel: {
      fileColumnNames: {
        currentRanking: 'Current Ranking',
        lastYearRanking: 'Last Year Ranking',
        assessable: 'Assessable',
        firstName: 'First Name',
        lastName: 'Last Name',
        title: 'Title',
        bu: 'BU',
        currentEvaluation: 'Current Evaluation',
        proposal: 'Proposal (X is for current evaluations that are not confirmed yet)',
        lastConfirmedEvaluation: 'Last Confirmed Evaluation',
        performance: 'Performance',
        id: 'ID',
      },
      importModal: {
        header: 'Import ranking',
        confirmButton: 'Apply Changes',
        description:
          'Here you can import the Excel ranking template. Please, remember to export a new copy instead of importing an old one you edited locally, since the data could have changed in the meantime. Also, remember to maintain the Excel columns order and structure, to avoid duplicating individual positions in the ranking and to position non-assessable employees (if any) at the bottom rows of the ranking. Top and Low tags must be managed via UI and follow your company percentages % guidelines.',
        processingMessage: 'The file is being processed. Please wait.',
        successMessage: 'The file was processed correctly',
        errors: {
          message1: 'Oops! A problem occurred while processing the file:',
          message2: 'No changes were made to the ranking. Please try again.',
          unknown: 'Unknown error while processing the file',
          noFile: 'No file selected',
          noType: 'Dropped file has no type',
          noPath: 'Dropped file has no path',
          extension: 'Dropped file is not .xlsx',
          duplicatedColumn: 'Duplicated header, check file headers.',
          noId: 'Missing employee ID at row {{rowNo}}',
          noRanking: 'Missing current ranking at row {{rowNo}}',
          rankingNaN: "Current ranking value '{{value}}' is not a number at line {{rowNo}}",
          noAssessableValue: 'Missing assessable value at line {{rowNo}}',
          wrongAssessableValue: "Current assessable value '{{value}}' is not valid at line {{rowNo}}. Accepted values: [0, 1]",
        },
        formatMessage: 'Accepted file format: .xlsx',
        notifications: {
          success: {
            title: 'Success',
            description: 'Imported Ranking successfully applied.',
          },
        },
      },
    },
    notifications: {
      save: {
        success: {
          title: 'Ranking saved',
          description: 'Ranking successfully saved.',
        },
        error: {
          title: 'Error while saving Ranking',
          description: 'An error occurred while saving the ranking. Please, try again.',
        },
      },
      confirm: {
        success: {
          title: 'Ranking confirmed',
          description: 'Ranking successfully confirmed.',
        },
        error: {
          title: 'Error while confirming Ranking',
          description: 'An error occurred while confirming the ranking. Please, try again.',
        },
      },
    },
  },

  pyramidsView: {
    networkCompanyCountryCascaderSearchPlaceholder: 'Search network, company or country…',
    empty: {
      heading: 'You currently have no companies with active employees',
      message: 'As soon as active employees are present, it will be possible to see and set up the pyramids',
    },
    type: {
      Age: 'Age',
      Level: 'Level',
    },
    shared: {
      infoBox: {
        settings: {
          heading: 'Settings',
          employees: 'employees',
          cascaderPlaceholder: 'Please select year and month',
          pyramidsMonthSelectionInfo:
            'Choose the moment in time you want to look at. You can compare the past situation with the current and a forecast of the future.',
        },
        editForecast: 'Edit forecast',
      },
      graph: {
        heading: {
          Age: 'Age',
          Level: 'Level',
        },
      },
      overview: {
        heading: 'Overview',
        recommended: 'Recommended',
        past: 'Past',
        current: 'Current',
        forecast: 'Forecast',
        variance: 'Variance',
        minMax: 'min. / max.',
        Min: 'min.',
        Max: 'max.',
        level: {
          total: 'Total',
          'C1 - C2': 'C1-C2',
          C: 'C',
          C1: 'C1',
          C2: 'C2',
          C3: 'C3',
          SC: 'SC',
          SC1: 'SC1',
          SC2: 'SC2',
          'PR - M': 'PR-M',
          PR: 'PR',
          M: 'M',
          'SPR - SM': 'SPR-SM',
          SPR: 'SPR',
          SM: 'SM',
          AP: 'AP',
          P: 'P',
          EP: 'EP',
          SP: 'SP',
          CO: 'CO',
          D: 'D',
          PRO: 'PRO',
          BO: 'BO',
          PM: 'PM',
          PCM: 'PCM',
          LEAD: 'LEAD',
          L: 'LEAD',
          null: 'N/A',
          undefined: 'N/A',
          NRL: 'N/A',
        },
      },
      legend: {
        heading: 'Legend',
        recommended: 'Recommended',
        recommendedRange: 'Recommended',
        current: 'Current',
        past: 'Past',
        forecast: 'Forecast',
        infoLevel: "The graph and overview doesn't take partners, leavers and low tagged employees into account.",
        infoAge: "The graph and overview doesn't take partners and leavers into account.",
      },
      visualization: {
        tooltip: {
          recommended: 'Recommended',
          employees: 'Employees',
          footnote: '% of employees',
        },
      },
    },
    forecastModal: {
      tabs: {
        activeEmployees: 'Current employees',
        newHirings: 'New hirings',
      },
      headings: {
        activeEmployees: 'Current employees',
        newHirings: 'New hirings',
      },
      buttons: {
        deleteForecast: 'Delete forecast',
        deleteEmployeesForecast: 'Delete employees forecast',
        deleteNewHirings: 'Delete new hirings forecast',
        deleteTooltip: 'Select at least one employee to delete',
        viewFilters: 'View filters',
        addNewHirings: 'Add new hirings',
        clear: 'Clear',
        tooltipResetNewSettings: 'Reset forecast',
        tooltipReset: 'Reset',
      },
      filters: {
        employeeFullName: 'Employee',
        employeePlaceholder: 'Select employee',
        businessUnitName: 'BU',
        buPlaceholder: 'Select BU',
        currentEmployeeLevel: 'Level',
        levelPlaceholder: 'Select level',
        careerPath: 'Path',
        pathPlaceholder: 'Select path',
        tags: 'Tags',
        tagsPlaceholder: 'Select tags',
        filtersApplied: 'Filters applied',
        clearFilters: 'Clear filters',
        howMany: 'How many (mandatory)',
        age: 'Age',
        dateofLevelChange: 'Date of level change',
      },
      path: {
        on: 'On Path',
        partially: 'Partially on path',
        not: 'Not on path',
      },
      timeDiff: {
        since: 'Since',
        leavesIn: 'Leaves in',
      },
      common: {
        selectLevel: 'Select level',
        noEmployee: 'No Employees found',
        noHirings: 'No new hirings added',
        sureDeleteForecast: 'Are you sure you want to delete the forecast?',
      },
      table: {
        name: 'Name',
        employee: 'Employee',
        bu: 'BU',
        level: 'Level',
        salary: 'Salary',
        bonus: 'Bonus',
        path: 'Path',
        tags: 'Tags',
        age: 'Age',
        startDate: 'Start date',
        endDate: 'End date',
        levelChange: 'Level change',
        dateofLevelChange: 'Hiring date',
        forecastDate: 'Forecast date',
        actions: 'Actions',
        placeholders: {
          name: 'Enter name',
          bu: 'Select BU',
          salary: 'Enter salary',
          bonus: 'Enter bonus',
          age: 'Enter age',
        },
      },
      errors: {
        required: 'Please fill in all required fields',
        response: 'Error saving pyramid forecast',
      },
      disclaimers: {
        employeeLevel: "The overview doesn't take partners, leavers and low tagged employees into account",
      },
      notifications: {
        success: {
          title: 'Forecast modal saved',
          description: 'Forecast modal successfully saved.',
        },
      },
    },
  },
  globalAdminView: {
    infoBox: {
      assignedRoles: {
        heading: 'Assigned Roles',
      },
      employees: {
        heading: 'Employees',
      },
      add: {
        heading: 'Add',
      },
      notifications: {
        hr: {
          success: {
            title: 'Success',
            description: 'Role HR {{role}} successfully added to {{employeeFirstName}} for {{country}}.',
          },
        },
        downloader: {
          success: {
            title: 'Success',
            description: 'Role Downloader successfully added to {{employeeFirstName}}.',
          },
        },
      },
    },
    modal: {
      addRoleTitle: 'Add role to employee',
      countryValueMissing: 'Please select a country.',
      employeeAndRoleValuesMissing: 'Please select an employee and a role type.',
      tooltipRoleMissing: 'Please select a role.',
      selectedEmployeeAlreadyHasDowloaderRole: 'Selected employee already has Dowloader role.',
      employee: {
        label: 'Employee',
        notFoundContent: 'Please type in some longer name or name matching failed...',
        placeholder: 'Please select an employee',
      },
      country: {
        label: 'Country',
        placeholder: 'Please select a country',
        noOptionsAvailable: 'No further HR roles available for selected employee.',
      },
      type: {
        label: 'Type',
        radioAdmin: 'HR Admin',
        radioReadonly: 'HR Readonly',
        radioDownloader: 'Downloader',
      },
      hrVisibility: {
        label: 'HR visibility',
        checkbox: 'Exclude visibility on HR companies',
      },
      removeRoleTitle: 'Delete role from employee',
      role: {
        label: 'Role',
        placeholder: 'Please select a role',
      },
    },
    table: {
      employee: {
        heading: 'Employee',
      },
      downloader: {
        heading: 'Downloader',
      },
      assignedTo: {
        heading: 'Assigned to',
        hrExcluded: 'HR excluded',
      },
      role: {
        heading: 'Role',
      },
      actions: {
        heading: 'Actions',
        deleteBtnTooltip: 'Remove roles from {{employee}}',
      },
      empty: {
        heading: 'Currently no HR roles are assigned to employees.',
      },
      notifications: {
        delete: {
          hr: {
            success: {
              title: 'Success',
              description: 'Role HR successfully deleted from {{employeeFirstName}}.',
            },
          },
          downloader: {
            success: {
              title: 'Success',
              description: 'Role Downloader successfully deleted from {{employeeFirstName}}.',
            },
          },
        },
      },
    },
  },

  meetingTypes: {
    Appraisal: 'Appraisal',
    AppraisalUpdate: 'Appraisal Update',
    OtherProbationTalk: 'Probation Talk',
    OtherProjectFeedback: 'Project Feedback',
    OtherGeneric: 'Feedback',
  },
  pastTargetsFooter: {
    contractualBonus: 'Open employment bonus',
    openTargetBonus: 'Open target bonus',
    toBePaid: 'To be paid',
    openTargets: 'Open targets',
    totalTargets: 'All targets',
    developemntTargets: 'Development targets',
    monetaryTargets: 'Monetary targets',
  },
  paymentFooter: {
    oneOff: 'One off payment',
    manualDeduction: 'Manual deduction',
    targetValue: 'Achieved targets',
    targetCorrection: 'Target correction',
    toBePaid: 'To be paid',
  },

  otherMeetings: {
    title: 'Welcome to the meeting',
    notes: {
      headline: 'Notes',
      placeholder: 'Please type in your notes.',
    },
    feedback: {
      headline: 'Feedback',
      placeholder: 'Please type in your feedback.',
    },
    confirmModal: {
      heading: 'Confirm your preparation',
      text: "Pleace notice if you proceed your preparation will be shared with {{reviewerName}} and you can't edit it anymore.",
    },
    hints: {
      headline: 'Hints',
      projectFeedback: {
        replyer: {
          why: {
            headline: 'Why a project feedback?',
            description:
              'In daily business, the exchange in the context of your project activities often concentrates on technical topics, while constructive conversations with focus on you are coming too short. The project feedback gives you and your reviewer the option to take time and concentrate on your role and responsibilities. Therefore, the project feedback can make an important contribution to a good and functioning communication culture, while strengthening the productivity level of every member of the project. It is also important for us to know whether current projects match with your skill set and interests as well as your thoughts on future projects.',
          },
          how: {
            headline: 'How to prepare yourself for the meeting?',
            description:
              'Please remember that your reviewer might not be as informed about the current project’s status. Therefore, please prepare a short overview about its status and achieved milestones. Furthermore, you can exchange yourself with your reviewer about current challenges to find solutions. For both of you, it is important to consider your role. Therefore, think about your contribution to the project’s progress and be able to reflect yourself on your strengths and weaknesses. If you feel the need of trainings or any development potential – there is room to talk about options in order to improve your contribution to this project and future challenges. Moreover, give your reviewer feedback of future projects you would prefer to work in and discuss further options.',
          },
        },
        reviewer: {
          description1:
            'Consider the REPLYER’s role in the project (e.g. new in the project or in a leading position) and be aware of the fit of your expectations. If those have not been fulfilled, please try to think of options how to offer support e.g. in trainings or events on TamTamy. Communicate your wishes regarding the contribution and development as detailed as possible. If you settle on any topics, it will be helpful to define specific results and a time line in order to track progress.Your feedback should be about collaboration and communication with project members as well as the REPLYER’s contribution and the self-initiative within the project. If you are not able to give any feedback by yourself, please check with colleagues, mentors or project members. Also, ask the client for feedback. ',
          description2:
            'Please ensure that you discuss the REPLYERS’s overall performance. It is important to discuss what has worked well and share positive feedback from colleagues and/or clients, as well as any constructive feedback. You should discuss the value that the REPLYER brings to Reply and to the projects that they have worked on, alongside any areas of development, including hard and soft skills.',
          description3:
            'Please feel free to contact your HR responsible in advance if you have any questions. The colleagues are very happy to brief you before the project feedback, give you precious advice or join the meeting.',
        },
        meeting: {
          description:
            'Present your feedback in the first-person perspective, and mention both strengths and weaknesses. If improvement is necessary, it will help you as well as the REPLYER to define specific results and a timeline for improvement. Make sure that you are aware of the REPLYER’s interests and aspirations and try, wherever possible, to match these preferences to projects. Even if the current project is not the perfect match, you should try to give a view of future projects which may be a better fit.',
          hrSupport: {
            headline: 'HR Support needed?',
            description:
              'Please feel free to contact your HR responsible in advance if you have any questions. The colleagues are very happy to brief you before the project feedback and give you precious advice.',
          },
        },
      },
      probationTalk: {
        replyer: {
          talk: {
            headline: 'The probation talk',
            description:
              'The probation talk is an opportunity for you and your reviewer to exchange about your first months. There is an agenda with suggestions on topics to help you in order to prepare yourself for the meeting. Your reviewer and you should feel free to add other topics to the agenda. Goal of the meeting is to find an alignment, to talk about your first months and if your expectations match.',
          },
          agenda: {
            headline: 'The agenda',
            description:
              'Both of you – you and your reviewer – will have the opportunity to give feedback to each other on the first months regarding previous work on current projects, relationships among each other, within the team as well with client(s). You also will have the opportunity to give your reviewer feedback on your onboarding and whether your expectations have matched with. Furthermore, you will have the chance to talk about future tasks as well as options for trainings and any other topics you would like to discuss.',
          },
          hrInvolved: {
            headline: 'If HR is also involved...',
            description:
              'Sometimes HR also takes part in the probation talk. This can have several reasons: For reviewers who have not done many probation talks, HR supports them and provides feedback for the reviewer. In addition, HR is interested in your feedback about your first months within REPLY as it helps us to shape the future of REPLY.',
          },
        },
        reviewer: {
          prep: {
            headline: 'Why your prep is so important',
            description:
              'Both you and the REPLYER should take the chance to explore whether the employment relationship is working well for both sides. In your invitation to the meeting, you have asked the REPLYER to be prepared for this meeting. Please ensure that you are prepared too, to guide the meeting effectively, and to show them that you value them and that their contribution to REPLY is important.',
          },
          feedback: {
            headline: 'Prepare your feedback too',
            point1:
              'Integration into the team and project work regarding cooperation and communication within the team, with reviewers and clients',
            point2: 'quality of their work, achievement of agreed goals during probation (milestones)',
            point3: 'Does the REPLYER fit your expectations?',
            description:
              'Please consider that any criticism shall be impartial and grounded by concrete reasons and examples. If you are not able to give any feedback by yourself, please check with colleagues, mentors or project members how the REPLYER is integrated into the team as well as other project members.',
          },
          targets: {
            headline: 'Targets for bonus',
            description:
              'If a bonus per fiscal year is agreed with the REPLYER in their employment please address this and let the REPLYER know that targets and bonus will be discussed in another meeting, which you will complete separately.',
          },
          hrSupport: {
            headline: 'HR Support needed?',
            description:
              'Are you responsible for a probation talk for the first time (in general or at REPLY) or do you like to receive feedback on yourself? If so, please feel free to contact your HR responsible in advance. The colleagues are happy to brief you before the probation talk but also to assist you during the meeting if you wish.',
          },
        },
        meeting: {
          remember: {
            headline: 'Remember',
            description:
              'For guidance through the meeting use the agenda - Try to express your feedback in a positive manner and speak in first-person perspective - Express criticism impartial and grounded by reasons - Let the REPLYER speak as much as possible and give them the chance to answer and express their point of view - Start with small talk - Offer your support, if needed - Reach binding and clear agreements.',
          },
          goals: {
            headline: 'Goals of the meeting',
            description:
              'You and the REPLYER should be aligned on the expectations of their job, including their key tasks and responsibilities. Please ensure that you discuss with them any skills or behaviors which require improvement in a constructive manner, providing examples where possible. Remember to offer the REPLYER guidance on how they can improve, including any relevant training or coaching. If the REPLYER is a recent new hire, please ensure that they have been well supported during on-boarding and are getting all the support they need to succeed.',
          },
          hrSupport: {
            headline: 'HR Support needed?',
            description:
              'Please feel free to contact your HR responsible in advance if you have any questions. The colleagues are very happy to brief you before the project feedback and give you precious advice.',
          },
        },
      },
      otherMeeting: {
        replyer: {
          why: {
            headline: 'Why does my reviewer want this meeting?',
            description:
              'Besides, the fixed dialogs there also is the option to discuss individual topics. In some cases, it is simply useful to have an option to record certain results so that nothing will be forgotten and both of you have the opportunity to reread all set goals or agreements of the past. Furthermore, it will be easier for you and your reviewer to follow your progress at REPLY and see your development. So take the chance to recapitulate the topic your reviewer likes to exchange on and feel free to make some notes on what you have discussed or agreed.',
          },
          how: {
            headline: 'How to prepare yourself for the meeting?',
            description:
              'The headline of the meeting invitation shall give you an overview about what your reviewer wants to address. Please read the agenda, which you will find in here. If you have any questions about the content of the meeting, the benefit or any goal please contact your reviewer in advance for being able to prepare yourself for the meeting.',
          },
        },
        reviewer: {
          content: {
            headline: 'Content of the meeting',
            description:
              'Before you talk to your REPLYER please think about the cause of the meeting, the content and what you would like to reach with this meeting. Please never use this meeting for a termination or a warning notice. In such cases, please contact your HR responsible in advance to check your possibilities and how to proceed.',
          },
        },
        meeting: {
          procedure: {
            headline: 'Procedure of meeting',
            description:
              'Start with small talk and inform the REPLYER of the meeting’s steps and use the agenda for guidance through the meeting. Furthermore, it is important – as for every meeting – to define the goal(s) of the meeting. Express your expectations of it and give your REPLYER the chance to comment them for finding an alignment.',
          },
          remember: {
            headline: 'Remember',
            description1: 'Please consider that any criticism shall be impartial and grounded on concrete reasons and examples.',
            description2:
              'Remember that the REPLYER has requested this meeting to discuss a specific topic as per the agenda in their invitation. Please ensure that this topic is the focus of the meeting. If you wish to discuss a different matter, please consider arranging a separate meeting. At the end of the meeting, write a summary including the agreed next steps, if applicable.',
          },
          hrSupport: {
            headline: 'HR Support needed?',
            description:
              'Please feel free to contact your HR responsible in advance if you have any questions. The colleagues are very happy to brief you before the project feedback and give you precious advice.',
          },
        },
      },
      meeting: {
        headline: 'Meeting hints headline',
        OtherProbationTalk: 'to be inserted in textfile: Probation talk hints for actual meeting',
        OtherProjectFeedback: 'to be inserted in textfile: Project feedback hints for actual meeting',
        OtherGeneric: 'to be inserted in textfile: General feedback meetings hints for actual meeting',
      },
      manager: {
        headline: 'Hints',
        OtherProbationTalk: 'to be inserted in textfile: Probation talk hints for manager',
        OtherProjectFeedback: 'to be inserted in textfile: Project feedback hints for manager',
        OtherGeneric: 'to be inserted in textfile: General feedback meetings hints for manager',
      },
      employee: {
        headline: 'Hints',
        OtherProjectFeedback: 'to be inserted in textfile: Project feedback hints for employee',
        OtherGeneric: 'to be inserted in textfile: General feedback meetings hints for employee',
      },
    },
    agendaHeadline: 'Agenda',
    protocol: {
      headline: 'Summary',
      placeholder: 'Write down the summary.',
    },
    notifications: {
      error: {
        title: 'Error',
        description: 'An error occurred. Please, try again.',
      },
    },
  },
  employeeList: {
    infoBox: {
      switchContent: 'Switch content',
      skillStatus: 'Skill status sync',
      skillStatusDescription: 'The skill statuses were synced from the Skill Center on {{date}}. Click to synchronize Skill status now.',
      skillStatusDescription2: 'Click the refresh button for an updated view.',
      switchContentDescription: 'By using the selector, you can display only active people or only those who have left in the table.',
      monetaryVisibilityDescription: 'By clicking the eye-shaped button, you can hide or display the monetary data of the replyers.',
      refreshError: 'An error occurred while syncing with the Skill Center.',
      noRefreshRequired: 'You need to wait some minutes more before triggering a new refresh.',
      affectedEmployees: 'Affected employees:',
      wrongResignedInfoDisclaimer1:
        'Some employees have incorrect status or missing contract information. Please contact HR to report the affected employees.',
      wrongResignedInfoDisclaimer2: 'Hover the icon to view the list of affected employees.',
      toggleMonetary: {
        heading: 'Monetary Visibility',
        button: {
          hide: 'Hide salary and bonus',
          show: 'Show salary and bonus',
        },
      },
      filters: {
        clear: 'Clear',
        clearFilters: 'Clear filters',
        noActiveFilters: 'No active filters',
        editFilters: 'Change current filters',
        addFilters: 'Add other filters',
        filter: 'Filter',
        careerPath: 'Careerpath',
        careerPathPlaceholder: 'Select careerpath',
        inline: 'Inline',
        outOfLine: 'Out of line',
        level: 'Employee level',
        levelPlaceholder: 'Select level',
        bu: 'Business unit',
        buPlaceholder: 'Select BU',
        skillStatus: 'Skill status',
        skillStatusPlaceholder: 'Select skill status',
        otherFilters: 'Add other filters',
      },
      notifications: {
        skillStatusSync: {
          success: {
            title: 'Skill Statuses synced',
            description: 'Skill Statuses successfully synced.',
          },
          error: {
            title: 'Error while syncing Skill Statuses',
            description: 'An error occurred while syncing the Skill Statuses. Please, try again.',
          },
        },
      },
    },
    filterBox: {
      employeecountheading: 'Filtered employees',
      employees: 'employees',
      filterheading: 'Filter',
      addFilterTooltip: 'Add filter for table data',
      editFilterTooltip: 'Edit filter for table data',
      deleteFilterTooltip: 'Delete filter',
      tags: {
        country: 'Country',
        employeeName: 'Name',
        currency: 'Currency',
        level: 'Level',
        startDate: 'Start date',
        endDate: 'End date',
        dateAfter: 'after',
        dateBefore: 'before',
        salary: 'Annual salary',
        targetBonus: 'Target bonus',
        resultScore: 'Evaluation score',
      },
    },
    filterModal: {
      title: 'Employee table filter',
      businessUnit: 'Business unit',
      businessUnitPlaceholder: 'Add business unit',
      name: 'Employee name',
      namePlaceholder: 'Add employee name',
      currency: 'Currency',
      country: 'Employee country',
      countryPlaceholder: 'Choose employee country',
      office: 'Office',
      officePlaceholder: 'Select office',
      level: 'Employee level',
      levelPlaceholder: 'Choose employee level',
      currencyPlaceholder: 'Select Currency',
      startDate: {
        dateAfter: 'Start date after',
        dateBefore: 'Start date before',
      },
      endDate: {
        dateAfter: 'End date after',
        dateBefore: 'End date before',
      },
      annualSalary: 'Annual salary',
      annualSalaryLowerLimitPlaceholder: 'Lower limit',
      annualSalaryUpperLimitPlaceholder: 'Upper limit',
      targetBonus: 'Target bonus',
      targetBonusLowerLimitPlaceholder: 'Lower limit',
      targetBonusUpperLimitPlaceholder: 'Upper limit',
      careerPath: 'Carrerpath',
      careerPathPlaceholder: 'Choose careerpath satus',
      evaluationScore: 'Evaluation score',
      evaluationScorePlaceholder: 'Add evaluation score',
    },
    table: {
      employee: 'Employee',
      employeeTooltip: 'Go to settings to change name display preference',
      assessableTooltip: 'Assessable',
      notAssessableTooltip: 'Not assessable',
      skillStatus: 'Skill status',
      level: 'Level',
      bu: 'BU',
      office: 'Office',
      officeNotAvailable: 'N/A',
      salary: 'Salary',
      targetBonus: 'Bonus',
      careerPath: 'Path',
      replyEntryDate: 'Start date',
      contractValidTo: 'End date',
      ranking: 'Talent tags',
      actions: 'Actions',
      noEmployees: 'No employees have been assigned to you yet.',
      noResult: 'No result available for given filter.',
      viewProfile: 'View profile',
      evaluationScore: 'Evaluation',
    },
    resignedEmployeeList: {
      table: {
        reason: 'Reason',
        openBonus: 'Open Bonus',
        historyTableTooltip: 'Meeting history of {{employeeName}}',
      },
      meetingsModal: {
        heading: 'Meeting History',
        subHeading: 'Of {{employeeName}}',
      },
    },
  },
  latestScoreGrid: {
    modal: {
      heading: "{{employeeFullName}}'s last evaluation grades",
    },
  },
  draftScoreGrid: {
    table: {
      descriptionHeading: 'Evaluation grids guidelines',
      description0:
        'Welcome to the new Evaluation Grids area. Here, you can export, import, and edit the evaluation grids of your company. This feature will support you in prefilling the Evaluation grids during your next Appraisal or Appraisal Update.',
      description1: 'How do I prefill the evaluation grids?',
      description1_1:
        'To prefill the grids in your next meetings, you can either edit each grid individually via "Edit" button, or edit them massively by following these steps:',
      description1_1_item1: 'Click "<0>Export</0>" to download the Excel template;',
      description1_1_item2: '<0>Insert all the grades</0> for each employee in the Excel; ',
      description1_1_item3: 'Click <0>“Import”</0>;',
      description1_1_item4: "Select which business unit's grids you want to update;",
      description1_1_item5: 'Choose your local Excel file.',
      description1_1_footer:
        "Meply will elaborate the file, automatically applying the inserted grades to each employee's next meeting preparation.",
      description2: 'Can I edit the imported values?',
      description2_1:
        'Yes, you can edit values even after importing. You have the option to either re-upload a new Excel template or manually edit through the “Edit” button, under the “Actions” column. Changes can also be made directly during meeting preparation.',
      description3: 'Can I upload only parts of the template?',
      description3_1:
        "Sure. You can upload as many rows as you like. Just <0>remember to maintain the template columns' structure and order</0>.",
      employee: 'Employee',
      viewProfile: 'View Profile',
      level: 'Level',
      bu: 'BU',
      latestEvaluation: 'Evaluation (Last confirmed)',
      draftEvaluation: 'Evaluation (New proposal)',
      actions: 'Actions',
      editTooltip: 'Edit new proposal evaluation grid',
      viewTooltip: 'View new proposal evaluation grid',
      latestEvaluationTooltip: 'View last confirmed evaluation grid',
      missingLastConfirmedEvaluationTooltip: 'No existing confirmed evaluation for {{employeeFullName}}',
      missingDraftEvaluationTooltip: 'No existing new proposal evaluation for {{employeeFullName}}',

      noEmployees: 'No employees have been assigned to you yet.',
    },
    modal: {
      editHeading: 'Edit evaluation grades',
      viewHeading: 'View evaluation grades',
      applyChanges: 'Apply changes',
      description:
        "Here you can edit <0>{{employeeName}}</0>'s evaluation grades. The values inserted here will not overwrite any data that were already confirmed during this appraisal season. Instead, they will be applied to the preparation of the next Appraisal or Appraisal Update meeting, and can be then further edited or confirmed.",
      notifications: {
        success: {
          title: 'Changes applied',
          description: 'Changes on Evaluation Grades of {{employeeFullName}} successfully applied.',
        },
        error: {
          title: 'Error while applying changes',
          description: 'An error occurred while applying the changes. Please, try again.',
        },
      },
    },
    importModal: {
      header: 'Import evaluation grids',
      confirmButton: 'Apply Changes',
      description:
        'Here you can import the Excel template with the evaluation grids for this company. The evaluations you import will be applied to the next, available Appraisal or Appraisal Update meeting drafts. You will still be able to edit them before confirming the meetings.',
      description2:
        "To import a file with the evaluation grids, first <0>select one or more business units</0> to which you wish to apply the changes. This ensures that only the rows with the business units you choose are updated. Once you've selected at least one business unit, you can upload your local Excel file.",
      processingMessage: 'The file is being processed. Please wait.',
      successMessage: 'The file was processed correctly',
      errors: {
        message1: 'Oops! A problem occurred while processing the file: ',
        message2: 'No changes were made to the evaluation grids. Please try again.',
        unknown: 'Unknown error while processing the file.',
        noFile: 'No file selected.',
        noType: 'Dropped file has no type.',
        noPath: 'Dropped file has no path.',
        extension: 'Dropped file is not ".xlsx".',
        duplicatedColumn: "Duplicated column '{{idColumnName}}' found",
        noId: 'Missing employee ID at row {{rowNo}}.',
        duplicatedId: 'Duplicated employee ID at rows {{rowNo1}} and {{rowNo2}}.',
        unknownEmployee:
          'Unknown Employee at row {{rowNo}}. It may be that he/she has been recently added to the company. If so, please reload the web page.',
        missingScoreGoal: 'Missing evaluation goal "{{name}}" at row {{rowNo}}.',
        scoreGoalNotInteger: 'Evaluation goal "{{name}}" is not an integer number at row {{rowNo}}.',
        invalidScoreGoalValue: '"{{name}}" has an invalid value of {{value}} at row {{rowNo}}. Please, choose any grade between 1 and 10.',
        noScoreGridType: 'Missing Evaluation Grid type at row {{rowNo}}.',
        unknownScoreGridType: 'Unknown Evaluation Grid type at row {{rowNo}}.',
        noChanges: 'Imported file would make no changes on current data.',
        noBuSelected: 'No business unit selected.',
        noEmployeeForSelectedBus: "The imported file doesn't include any employee from the BU you selected.",
      },
      formatMessage: 'Accepted file format: .xlsx',
      all: 'ALL',
      notifications: {
        success: {
          title: 'Evaluation Grid imported',
          description: 'Evaluation Grid successfully imported.',
        },
      },
    },
    excel: {
      fileColumnNames: {
        id: 'ID',
        firstName: 'FIRST NAME',
        lastName: 'LAST NAME',
        bu: 'BUSINESS UNIT',
        title: 'TITLE',
        draft: 'Draft',
        confirmed: 'Last Confirmed',
        evaluationLastConfirmed: 'EVALUATION (LAST CONFIRMED)',
        evaluationNewProposal: 'EVALUATION (NEW PROPOSAL)',
        scoreGoal: {
          Customer_1: 'Customer Focus',
          Customer_2: 'Responsibility',
          Customer_3: 'Communication with clients',
          Customer_4: 'Proactivity',
          Customer_5: 'Business Development',
          Speed_1: 'Problem Solving',
          Speed_2: 'Organizational Capability',
          Speed_3: 'Target Focus',
          Teamwork_1: 'Knowledge Sharing',
          Teamwork_2: 'People Management ',
          Teamwork_3: 'Communication with colleagues',
          Excellence_1: 'Competences and Specialisations',
          Excellence_2: 'Job Quality',
          Excellence_3: 'Continuous Learning Excellence',
          Innovation_1: 'Innovation Propensity',
          Innovation_2: 'Continuous Learning Innovation',
          HumanValues_1: 'Adherence to Reply Values',
          HumanValues_2: 'Culture and Principles Alignment',
        },
      },
    },
  },
  targetView: {
    emptyTable: {
      monetary: "Looks like you don't have any monetary targets yet.",
      development: "Looks like you don't have any development targets yet.",
      infoText: 'You can request an appraisal or appraisal update with your manager.',
      resignedView: "{{name}} didn't have any {{targetType}} targets.",
      public: {
        monetary: 'There are no monetary targets yet.',
        development: 'There are no development targets yet.',
        infoText: 'You can invite him/her.',
      },
    },
  },
  ownGrowthView: {
    meetingStatus: {
      manager: {
        plannedMeeting: '{{employeeFullName}} has a meeting with {{reviewerFullName}} on {{dateOfMeeting}}.',
        plannedMeetingWithYou: '{{employeeFullName}} has a meeting with you on {{dateOfMeeting}}.',
        waitingForConfirmation:
          'Currently no active targets because the last appraisal is not yet confirmed or got disputed by {{employeeFullName}}.',
      },
      startPreparation: {
        actionMessage: 'Go to <0>{{typeOfMeeting}} Preparation</0>',
        secondaryMessage: 'You have a meeting with {{reviewerFullName}} on {{dateOfMeeting}}',
      },
      viewPreparation: {
        actionMessage: 'View <0>{{typeOfMeeting}} Preparation</0>',
        secondaryMessage: 'You have a meeting with {{reviewerFullName}} on {{dateOfMeeting}}',
      },
      viewAndConfirm: {
        actionMessage: 'View <0>{{typeOfMeeting}} Conclusion</0> and confirm.',
        secondaryMessage: 'You had a meeting with {{reviewerFullName}} on {{dateOfMeeting}}',
      },
      disputedMeeting: {
        actionMessage: 'View <0>{{typeOfMeeting}} Conclusion</0> and wait for HR Review.',
        secondaryMessage: 'You disputed the meeting on {{dateOfMeeting}}',
      },
    },
    tabs: {
      targets: 'Targets',
      evaluation: 'Evaluation',
    },
    noData: {
      employee: {
        title: "You didn't do any Evaluation during your last appraisal.",
      },
      profile: {
        title: "Employee didn't do any Evaluation during his/her last appraisal.",
      },
    },
    grid: {
      appraisalLabel: 'Meeting',
      appraisalPreparationLabel: 'Your preparation',
      category: {
        Overview: 'Overview',
        Customer: 'Customer',
        Speed: 'Speed',
        Teamwork: 'Teamwork',
        Excellence: 'Excellence',
        Innovation: 'Innovation',
        HumanValues: 'Human values',
      },
      noData: {
        date: '-',
      },
    },
    overview: {
      title: 'Overview over all values',
      chart: {
        legend: {
          appraisal: 'Meeting {{date}}',
          preparation: 'Preparation {{date}}',
        },
        xAxisScoreType: {
          Customer_1: 'Customer Focus',
          Customer_2: 'Responsibility',
          Customer_3: 'Communication',
          Customer_4: 'Proactivity',
          Customer_5: 'Business Development',
          Speed_1: 'Problem Solving',
          Speed_2: 'Organizational Capability',
          Speed_3: 'Target Focus',
          Teamwork_1: 'Knowledge Sharing',
          Teamwork_2: 'People Management ',
          Teamwork_3: 'Communication',
          Excellence_1: 'Competences and Specialisations',
          Excellence_2: 'Job Quality',
          Excellence_3: 'Continuous Learning',
          Innovation_1: 'Innovation Propensity',
          Innovation_2: 'Continuous Learning',
          HumanValues_1: 'Adherence to Reply Values',
          HumanValues_2: 'Culture and Principles Alignment',
        },
        xAxisScoreCategory: {
          Customer: 'Customer',
          Speed: 'Speed',
          Teamwork: 'Teamwork',
          Excellence: 'Excellence',
          Innovation: 'Innovation',
          HumanValues: 'Human Values',
        },
      },
    },
  },
  meetingView: {
    managerMeetings: {
      tab: 'Meetings as a reviewer',
      noMeetingsTitle: 'You have no upcoming meetings at the moment.',
      noMeetingsText: 'Do you want to invite an employee?',
      noMeetingsNoEmployeesText: "You can't invite someone, because you have no employee assigned to you yet.",
      elapsedMeetingsAvailableHeader: 'You only have elapsed meetings at the moment.',
    },
    ownMeetings: {
      tab: 'My meetings',
      noMeetingsTitleMeetingEmployee: 'This is your first meeting.',
      noMeetingsTitleMeetingReviewer: "This is {{employee}}'s first meeting.",
      noMeetingsTitleRequest: "You haven't had any meetings yet.",
      noMeetingsTilePublicProfile: 'There are no meetings yet.',
      noMeetingsTextMeetingEmployee: "You haven't had any meetings yet.",
      noMeetingsHistory: "You didn't have any meeting in the past.",
      noMeetingsTextMeetingReviewer: 'There are no meetings yet.',
      noMeetingsTextRequest: 'Do you want to request one?',
      noMeetingsTextResignedEmployee: `{{name}} didn't have any meetings.`,
      noMeetingsTextPublicProfile: 'Do you want to invite now?',
    },
    allMeetings: {
      tab: 'Subordinate meetings',
      noMeetingsTitle: 'None of your subordinates have meetings at the moment.',
      date: 'Date',
      appraisalSeason: 'Season',
      type: 'Type',
      employee: 'Employee',
      reviewer: 'Reviewer',
      status: 'Status',
      assignToMe: 'Assign to me',
      table: {
        footerText: '{{range}}-{{range1}} of {{total}} meetings',
      },
      confirmModal: {
        heading: 'Confirm take over',
        subheading: "For {{reviewer}}'s {{meetingType}} meeting with {{employee}} on {{date}}",
        text1: 'Are you sure you want to take over this meeting?',
        text2:
          'If you proceed you will be responsible for it and only others will be able to reverse this action. {{reviewer}} and {{employee}} will receive an e-mail notification about this change.',
        notifications: {
          reassign: {
            success: {
              title: 'Success',
              description: 'Meeting successfully reassigned to you.',
            },
          },
        },
      },
    },
    requestedMeetings: {
      tab: 'Requested Meetings',
      table: {
        requestedOn: 'Requested on',
        type: 'Type',
        appraisalSeason: 'Season',
        employee: 'Employee',
        reason: 'Reason',
        empty: 'At the moment nobody requested a meeting with you.',
      },
      button: {
        tagAssignmentIsInProgress: 'Tag assignment is in progress so you are not able to accept or decline this request',
        invalidRequest: 'Selected meeting request is not valid.',
      },
      modal: {
        accept: {
          title: 'Accept meeting request',
        },
        decline: {
          title: 'Decline meeting request',
          reasonOfRejection: {
            label: 'Reason of rejection',
            placeholder: 'Please tell {{employeeName}} why you reject the meeting request.',
          },
        },
        shared: {
          subtitle: 'Of {{employeeFullName}}',
        },
        notifications: {
          success: {
            title: 'Success',
            description: 'Meeting requested by {{requesterFirstName}} has been successfully declined.',
          },
        },
      },
    },
  },
  appraisalMeetingStatus: {
    title: 'Appr. Status',
    noAppraisal: ' had no appraisal meeting this year',
    prep: ' did not prepare yet',
    prepFinished: ' finished the preparation',
    confirmPendingStart: 'Waiting for ',
    confirmPendingEnd: ' to confirm',
    confirmed: 'Confirmed appraisal',
    disputedConfirmed: 'Disputed confirmed appraisal',
  },
  meetingButtonActions: {
    invite: 'Invite',
    prep: 'Prepare {{meetingType}}',
    start: 'Start {{meetingType}}',
    reschedule: 'Reschedule',
  },
  managerMeetings: {
    date: 'Date',
    appraisalSeason: 'Season',
    type: 'Type',
    employee: 'Employee',
    status: 'Employee status',
    actions: 'Actions',
    tooltip: {
      cancel: 'Cancel meeting',
      viewPdf: 'View conclusion',
      viewPdfDisabled: 'Conclusion is not generated yet',
      forceConfirmation: 'Force meeting confirmation',
      inactiveEmployee: 'A resigned employee meeting could not be completed or rescheduled.',
    },
    table: { footerText: '{{range}}-{{range1}} of {{total}} meetings' },
    cancelMeetingModal: {
      header: 'Meeting Cancellation',
      description: 'Are you sure you want to delete the meeting?',
      description1:
        'The preparation from you and your employees will be lost. You can also reschedule the meeting or hand over the meeting to somebody else. In this case all preparation will be available.',
      placeholder: 'Reason for canceling meeting ...',
      cancel: "No, don't cancel meeting",
      confirm: 'Yes, cancel meeting',
      notifications: {
        success: {
          title: 'Success',
          description: 'Meeting successfully canceled.',
        },
      },
      error: 'An error occured while canceling the meeting. Please, try again.',
    },
  },
  employeeInvite: {
    headline: 'Request meeting',
    headlineAppraisal: 'Request {{appraisalType}}',
    request: 'Request',
    cancel: 'Cancel',
    status: 'Status',
    validation: {
      tooltip: 'Please change reason text',
      serverError: 'Server validation error. Please, reload the page and try again.',
    },
    meetingType: 'Meeting type',
    reviewer: 'Reviewer',
    requester: 'Requester',
    reason: 'Reason and additional information',
    reasonPlaceholder: 'Why do you want to have a meeting and do you want to suggest some time slots?',
  },
  meetingInvite: {
    appraisalSeason: 'Appraisal Season',
    appraisalSeasonDisclaimer:
      'Based on the date and hour you selected, the meeting will be part of the Appraisal Season {{appraisalSeasonYear}}.',
    appraisalSeasonPlaceholder: 'Select Appraisal Season',
    additionalParticipants: 'Additional participant',
    additionalParticipantsPlaceholder: 'Add participant',
    loading: "Loading employee's meeting options.",
    headline: 'Invite employee to Meeting',
    headlineEmployeeInvite: 'Invite {{employee}}',
    headlineReschedule: 'Reschedule this Meeting',
    meetingDate: 'Date',
    duration: 'Duration',
    hour: 'hour',
    hours: 'hours',
    meetingTime: 'Time',
    location: 'Location',
    locationPlaceholder: 'Meeting Location',
    meetingInviteEmployee: 'Employee',
    notFoundEmployee: 'Employee not found',
    reviewerNotAuthorized: 'You are not the reviewer of this employee',
    meetingType: 'Type',
    meetingAgenda: 'Agenda',
    emailText: 'Email',
    meetingAgendaPlaceholder: 'Please type in the meeting agenda',
    noAppraisalAvailable: 'It is not possible to invite {{employeeFirstName}} to an {{meetingType}} at the moment.',
    skillStatus: 'Skill status',
    skillStatusRetrievalErrorTooltip: 'Unable to retrieve current skill status',
    skillStatusInfoCard: {
      section1:
        'We noticed that it has been over a year since you last updated your skill in the skill center. As we approach the upcoming appraisal period, having your skills and achievements up-to-date is crucial to ensuring an accurate and thorough evaluation during the process.',
      section2:
        'Updating your profile will not only highlight your recent accomplishments but also provide visibility for potential new opportunities within the company.',
      section3:
        'We encourage you to take a few moments to review and refresh your "My Skill", it will unlock the possibility to have meetings on MEPLY with your reviewer.',
      section4: 'Thank you.',
    },
    reasonForReducedSteps: {
      header: 'Reason for reduced steps',
      placeholder: 'Reason for reducing steps',
      Resigned: 'Resigned',
      NewStarter: 'New Starter',
      LongTermSickness: 'Long-term Sickness',
      Sabatical: 'Sabatical',
      ParentalLeave: 'Parental Leave',
      Other: 'Other reason',
    },
    type: {
      yearly: 'Yearly Appraisal',
      midyear: 'Appraisal Update',
    },
    steps: {
      pastTargets: 'Past targets (includes payments)',
      newTargets: 'New targets',
      selfReflection: 'Self-reflection',
      evaluation: 'Evaluation',
      contractChanges: 'Employment changes',
      contractChangesTargetsPayments: 'Employment changes, targets and payments',
      payments: 'Payments',
    },
    doScheduleButton: 'Invite',
    requestSkillUpdate: 'Request skill update',
    requestSkillUpdateButtonTooltip: 'Send reminder email',
    doScheduleDisabledEmailAndAgendaTooltip: 'Please change the Agenda and E-Mail text.',
    doScheduleDisabledEmailTooltip: 'Please change the E-Mail text.',
    doScheduleDisabledAgendaTooltip: 'Please change the Agenda text.',
    invalidDateTimeTooltip: 'Please enter correct Date and Time.',
    invalidMeetingRequest: 'You cannot accept this request right now',
    unknownSkillStatus: 'No skill status found',
    doRescheduleButton: 'Reschedule',
    rescheduleToNow: 'Now',
    cannotRescheduleToNow: 'Cannot reschedule this meeting to current date.',
    templates: {
      agenda: {
        other:
          '<p>An agenda has to be defined before sending invitation to the REPLYER.</p>' +
          '<p>PLEASE DEFINE A HEADLINE AND AN AGENDA.</p>' +
          '<p>Feedback meeting: Please confirm the purpose of the meeting e.g., a midterm review, return from parental leave or longer sickness, time, or stress management, etc. If you would like the REPLYER to bring any documents or anything else necessary for the meeting, please add this information here too. Please let the REPLYER know that it is a two-way dialogue and that they should prepare accordingly. Please also define a short agenda with approximately four specific topics which you want to discuss with the REPLYER.</p>',
        projectFeedback:
          '<p>1. Induction</p>' +
          '<ol>' +
          '<li>Meeting during the project: Current status and achieved milestones OR</li>' +
          '<li>Meeting at the end of the project: Achieved milestones &amp; project results </li>' +
          '</ol>' +
          '<p>2. (Current) challenges </p>' +
          '<ul>' +
          '<li>Reasons, e.g. systems, know how, client communication, etc. </li>' +
          '<li>Developing a strategy of coping any challenges </li>' +
          '</ul>' +
          '<p>3. Successes</p>' +
          '<ul>' +
          '<li>What has worked well e.g. within the project team, feedback of client, etc. </li>' +
          '</ul>' +
          '<p>4. Things to improve</p>' +
          '<ul>' +
          '<li>Match of skills and interests with current project</li>' +
          '<li>Hard skills, e.g. knowledge of systems</li>' +
          '<li>Soft skills, e.g. communication and time management</li>' +
          '</ul>' +
          '<p>5. Alignment</p>' +
          '<ul>' +
          '<li>Definition of future steps (e.g. trainings regarding hard and soft skills, knowledge transfer possibly in TamTamy) and future projects and tasks</li>' +
          '<li>One step further – preferred projects fields in the future</li>' +
          '</ul>' +
          '<p>6.	Other topics</p><p><br></p>',
        probationTalk:
          '<p>1. Induction</p>' +
          '<ul>' +
          '<li>Small talk and role definition of participants</li>' +
          '<li>Option to review the first months</li>' +
          '</ul>' +
          '<p>2. Manager’s Feedback </p>' +
          '<ul>' +
          '<li>feedback of the manager &amp; client regarding project work</li>' +
          '<li>satisfaction of manager &amp; client</li>' +
          '<li>communication and collaboration within the team, with reviewers and clients</li>' +
          '<li>work life balance</li>' +
          '<li>other topics</li>' +
          '</ul>' +
          '<p>3. REPLYER’s feedback on</p>' +
          '<ul>' +
          '<li>onboarding</li>' +
          '<li>tasks and skills </li>' +
          '<li>Match of expectations of the application procedure</li>' +
          '<li>other topics</li>' +
          '</ul>' +
          '<p>4. Perspective and alignment </p>' +
          '<ul>' +
          '<li>on REPLYER’s wishes for the future regarding tasks, trainings etc. and </li>' +
          '<li>on Reviewer’s idea for the future </li>' +
          '<li>Finding an alignment regarding future tasks and development options </li>' +
          '</ul><p><br></p>',
      },
      email: {
        other:
          '<p>Dear {{employeeFirstName}},</p>' +
          '<p>I would like to talk to you about XXXX</p><p>The goal of the meeting will be xxxx</p>' +
          '<p>Both of us are able to prepare this meeting in MEPLY. Please log in to the tool and enter the preparation. Optionally, it is possible for you to share your preparation with me. </p>' +
          '<p>This invitation is being sent by MEPLY, thus you cannot respond to this mail (or: the sender) directly. In case the meeting time or date doesn’t suit you, please get directly in touch with me to find a different slot.</p>' +
          '<p>I am looking forward to our meeting.</p>' +
          '<p>Kind regards,</p>' +
          '<p>{{reviewerFirstName}}</p><p><br></p>',
        projectFeedback:
          '<p>Dear {{employeeFirstName}},</p>' +
          '<p>I would like to talk to you about our project XXXX.</p>' +
          '<p>In this meeting, we can exchange about the project’s status, which includes the achieved milestones and the current challenges. Let’s exchange ideas how to deal with the challenges.</p>' +
          '<p>The goal of our meeting will be finding an alignment regarding future steps. I am also looking forward to hearing your thoughts on future projects.</p>' +
          '<p>Both of us are able to prepare this meeting in MEPLY. Please log in to the tool and enter the preparation. Optionally, it is possible for you to share your preparation with me.</p>' +
          '<p>In case the meeting time or date doesn’t suit you, please get directly in touch with me to find a different slot.</p>' +
          '<p>Kind regards,</p>' +
          '<p><a href="" rel="noopener noreferrer" target="_blank">{{reviewerFirstName}}</a></p><p><br></p>',
        probationTalk:
          '<p>Dear {{employeeFirstName}},</p>' +
          '<p> I would like to hear about your impressions of your first months at REPLY and give you some feedback on your work. Please think about your onboarding, the projects you were working on, the communication in the team etc. Let’s also talk about our expectations for the future.</p>' +
          '<p> Both of us are able to prepare this meeting in MEPLY. Please log in to the tool and enter the preparation. Optionally, it is possible for you to share your preparation with me.</p>' +
          '<p> In case the meeting time or date doesn’t suit you, please get directly in touch with me to find a different slot.</p>' +
          '<p>I am looking forward to hearing about your first impressions.</p>' +
          '<p>Kind regards,</p>' +
          '<p>{{reviewerFirstName}}</p><p><br></p>',
        appraisal:
          '<p>Dear {{employeeFirstName}},</p>' +
          '<p>I would like to invite you to our yearly appraisal meeting. In this meeting, we have the chance to talk about your last months at Reply, your development and the next steps of your career. Both of us are able to prepare this meeting in MEPLY. Please log in to the tool and enter the preparation. Optionally, it is possible for you to share your preparation with me. MEPLY gives us suggestions what we can talk about but there is also room for other topics.</p>' +
          '<p> In case the meeting time or date doesn’t suit you, please get directly in touch with me to find a different slot.</p>' +
          '<p>Kind regards,</p>' +
          '<p>{{reviewerFirstName}}</p><p><br></p>',
        appraisalUpdate:
          '<p>Dear {{employeeFirstName}},</p>' +
          '<p>I would like to invite you to an appraisal update meeting. In this meeting, we have the chance to review the steps we were already talking about for this year. There is also the possibility to mark targets as done and add other ones. Both of us are able to prepare this meeting in MEPLY. Please log in to the tool and enter the preparation. Optionally, it is possible for you to share your preparation with me.</p>' +
          '<p> In case the meeting time or date doesn’t suit you, please get directly in touch with me to find a different slot.</p>' +
          '<p>Kind regards,</p>' +
          '<p>{{reviewerFirstName}}</p><p><br></p>',
      },
    },
    notifications: {
      invite: {
        success: {
          title: 'Employee invited',
          description: '{{employeeName}} has been successfully invited.',
        },
      },
      accept: {
        success: {
          title: 'Request accepted',
          description: 'Meeting requested by {{employeeName}} has been successfully accepted.',
        },
      },
    },
  },
  meetingRequest: {
    button: 'Request meeting',
    notifications: {
      title: 'Request sent',
      description: 'Request to {{reviewerName}} has been successfully sent.',
    },
  },
  okr: {
    outdatedTargets: 'Outdated targets',
    monetary: {
      title: 'Monetary targets',
      emptyTableTitle: 'There are no monetary targets scheduled.',
      emptyTableText: 'Please add some.',
      emptyTablePastTitle: "{{employee}} didn't have a monetary target, but has a target bonus from last year",
      emptyTablePastText: 'Please add a new monetary target here.',
    },
    development: {
      title: 'Development targets',
      emptyTableTitle: 'There are no development targets scheduled.',
      emptyTableText: 'Please add some.',
      emptyTablePastTitle: "{{employee}} didn't have any development targets.",
      emptyTablePastText: 'Please add a new development target here.',
    },
    pastDevelopment: {
      title: 'Development targets',
      emptyTableTitle: 'There are no development targets scheduled.',
      emptyTableText: 'Please add some.',
      emptyTablePastTitle: "didn't have any development targets.",
      emptyTablePastText: 'Please add a new development target here.',
    },
    suggestion: {
      title: 'Suggestion',
      emptyTableTitle: "You don't have any target suggestions yet.",
      emptyTableText: 'Add some for your manager.',
    },
    objective: {
      appraisalSeason: 'Season',
      title: 'Please add the targets title',
      description: 'Description',
      start: 'Start date',
      due: 'Due date',
      attachment: 'Attachment',
      keyResults: {
        tasks: 'Tasks',
        placeholder: 'Describe the task',
        header: 'Tasks',
        add: 'Add',
        new: 'New task',
        keyResultsInputPlaceholder: 'Create new task',
        maxCharactersDescription: 'Total of characters for all tasks',
        makeMonetary: 'Make monetary',
        removeMonetaryOption: 'Remove monetary option',
        achievedAmount: 'Achieved amount',
        maxCharacterInfo:
          'Please keep in mind you can only use a maximum of {{number}} characters for all tasks in total. To add another task, you either have to remove or reduce an existing task.',
      },
      creator: 'Proposed by',
      notes: {
        header: 'Comments',
        add: 'Add',
        new: 'New comment',
      },
      actions: 'Actions',
      monetary: {
        bonus: 'Bonus',
        toBePaid: 'To be paid',
        reached: 'Reached',
      },
      status: {
        title: 'Status',
        proposal: 'New',
        approved: 'Active',
        markedAsDone: 'To be closed',
        readyForPayOff: 'Ready for pay-off',
        dismissedPending: 'Dismissed',
        closed: 'Closed',
        creator: {
          proposalFromManager: 'Company',
          proposalFromEmployee: 'Employee',
        },
      },
      modal: {
        defaultHeader: 'Target',
        monetaryHeadline: 'Monetary target',
        developHeadline: 'Development target',
        empNewTarget: 'Target suggestion',
        startDate: 'Start date',
        dueDate: 'Due date',
        closedOn: 'Closed on',
        managerNewTarget: 'New Target',
        markAsDone: 'Mark as done',
        markedAsDone: 'Marked as done',
        targetAmount: 'Target amount',
        achievedAmount: 'Achieved amount',
        achievedAmountPercentage: 'Achieved percentage',
        selectFromTemplate: 'Select from template',
        attachment: 'Attachment',
        dropzone: "Drag 'n' drop one file here, or click to select one file",
        dropzoneHovered: 'Drop the file here ...',
        tooLarge: 'File exceeds maximum file size of 10 MB!',
      },
    },
    instructions: {
      employee: {
        review: 'Review your active targets',
        suggest: 'Suggest new targets',
      },
      manager: {
        review: "Review {{name}}'s active targets",
        create: 'New targets',
        outdatedTargets: 'Outdated targets',
      },
    },
    save: 'Save',
  },
  employee: {
    contract: {
      level: {
        'C1 - C2': 'Consultant 1 - Consultant 2',
        C: 'Consultant',
        C1: 'Consultant 1',
        C2: 'Consultant 2',
        C3: 'Consultant 3',
        SC: 'Senior Consultant',
        SC1: 'Senior Consultant 1',
        SC2: 'Senior Consultant 2',
        'PR - M': 'Principal - Manager',
        PR: 'Principal',
        M: 'Manager',
        'SPR - SM': 'Senior Principal - Senior Manager',
        SPR: 'Senior Principal',
        SM: 'Senior Manager',
        AP: 'Associate Partner',
        P: 'Partner',
        EP: 'Executive Partner',
        SP: 'Senior Partner',
        CO: 'Chief Officer',
        D: 'Director',
        PRO: 'Prokurist',
        BO: 'Board',
        PM: 'Project Manager',
        PCM: 'Profit Center Manager',
        LEAD: 'Lead',
        null: 'Undefined',
        undefined: 'Undefined',
        NRL: 'Unknown Level',
        L: 'Lead',
        LC: 'LeavesComp',
      },
    },
    nationalContract: {
      type: {
        COMMERCIO: 'COMMERCIO',
        COMMERCIO_STANDARD_MI: 'COMMERCIO STANDARD MI',
        COMMERCIO_STANDARD_RM: 'COMMERCIO STANDARD RM',
        COMMERCIO_STANDARD_TO: 'COMMERCIO STANDARD TO',
        COMMERCIO_BITMAMA: 'COMMERCIO BITMAMA',
        COMMERCIO_LEM: 'COMMERCIO LEM',
        INDUSTRIA: 'INDUSTRIA',
        DIR_INDUSTRIA: 'DIR INDUSTRIA',
        GRAFICO: 'GRAFICO',
        GRAFICO_EOS: 'GRAFICO EOS',
        TLC: 'TLC',
      },
      shortType: {
        COMMERCIO: 'COMMERCIO',
        COMMERCIO_STANDARD_MI: 'COMMERCIO',
        COMMERCIO_STANDARD_RM: 'COMMERCIO',
        COMMERCIO_STANDARD_TO: 'COMMERCIO',
        COMMERCIO_BITMAMA: 'COMMERCIO',
        COMMERCIO_LEM: 'COMMERCIO',
        INDUSTRIA: 'INDUSTRIA',
        DIR_INDUSTRIA: 'DIR-INDUSTRIA',
        GRAFICO: 'GRAFICO',
        GRAFICO_EOS: 'GRAFICO',
        TLC: 'TLC',
      },
      level: {
        E: 'E',
        I: 'I',
        II: 'II',
        III: 'III',
        IV: 'IV',
        V: 'V',
        VI: 'VI',
        VII: 'VII',
        Q: 'Q',
        DIR: 'DIR',
        OPE1: 'OPE1',
        D1: 'D1',
        D2: 'D2',
        C1: 'C1',
        C2: 'C2',
        C3: 'C3',
        C4: 'C4',
        B1: 'B1',
        B2: 'B2',
        B3: 'B3',
        B1S: 'B1S',
        B15: 'B15',
        A: 'A',
        A1: 'A1',
        A2: 'A2',
        AC: 'AC',
        AS: 'AS',
        ASC: 'ASC',
        TWO: '2',
        THREE: '3',
        FOUR: '4',
        FIVE: '5',
        FIVE_S: '5S',
        SIX: '6',
        SEVEN: '7',
        SEVEN_Q: '7Q',
        EIGHT_Q: '8Q',
        L: 'L',
      },
    },
    address: {
      type: {
        PRIMARY: 'Primary',
        SECONDARY: 'Secondary',
      },
    },
    emergencyContacts: {
      type: {
        PRIMARY: 'Primary',
        SECONDARY: 'Secondary',
      },
    },
  },
  profile: {
    tabs: {
      personalData: 'Personal Data',
      employment: 'Employment',
      overview: 'Overview',
      targets: 'Targets',
      meetings: 'Meetings',
      notes: 'Notes',
      evaluation: 'Evaluation',
    },
    executedPayment: {
      ONE_OFF: 'One Off',
      TARGET_BONUS: 'Target Bonus',
      RETENTION: 'Retention',
      VARIABLE_SALARY_COMPONENT: 'Variable Salary Component',
      VALUABLE_HOURS: 'Valuable Hours',
      CAR_ALLOWANCE: 'Car Allowance',
      TARGET_BONUS_PREPAYMENT: 'Target Bonus Prepayment',
      RAF: 'Refer a Friend',
      WARRANTS: 'Warrants',
    },
    meetings: {
      nextMeetings: 'Next Meetings',
      request: {
        missingReviewerTooltip: 'No reviewer available',
        missingMeetingOptionTooltip: 'Please, check the status of your pending requests.',
        appraisalNotAvailableTooltip: 'It is not possible to request an {{appraisalType}} at the moment.',
        appraisalAlreadyRequestedTooltip: 'You have already requested an Appraisal or an Appraisal Update.',
      },
      invite: {
        appraisalNotAvailableTooltip: '{{employeeName}} cannot be invited to an {{appraisalType}} at the moment.',
      },
    },
    targets: {
      modalHeadline: 'Target: ',
    },
    personalData: {
      header: 'Employee Information',
      legalFirstName: 'Legal first name',
      legalLastName: 'Legal last name',
      chosenFirstName: 'Chosen first name',
      chosenLastName: 'Chosen last name',
      academicTitle: 'Academic title',
      dateOfBirth: 'Date of birth',
      gender: 'Gender',
      citizenships: 'Citizenships',
      replyEntryDate: 'Reply entry date',
      privateEmailAddress: 'Private e-mail',
    },
    emergencyContacts: {
      header: 'Emergency contacts',
      name: 'Name',
      emailAddress: 'E-mail',
      phoneNumber: 'Private Phone Number',
      type: 'Type',
      emptyTable: "You didn't add any emergency contacts.",
    },
    address: {
      header: 'Addresses',
      address: 'Address',
      phoneNumber: 'Private Phone Number',
      stateRegion: 'Country',
      emptyTable: "You didn't add any addresses.",
    },
    contract: {
      header: 'Job Summary',
      headerResigned: 'Last Employment',
      virtualCompanyEntryDate: 'Start date',
      endingDate: 'Ending date',
      endingReason: 'Ending reason',
      type: 'Employment type',
      level: 'Employee level',
      careerPath: 'Career path',
      rankingTag: 'Talent Tags',
      currentAnnualSalary: 'Annual salary',
      currentMonthlySalary: 'Monthly salary',
      currentTargetBonus: 'Target bonus',
      currentHiringOffice: 'Hiring Office',
      currentDepartment: 'Department',
      currentTitle: 'Title',
      bankAccount: 'Bank account',
      virtualCompany: 'Company',
      businessUnit: 'Business Unit',
      branchOffice: 'Office',
      legalEntity: 'Legal Entity',
      companyCar: {
        label: 'Company car',
        deduction: 'Deduction',
      },
      carAllowance: {
        label: 'Car allowance',
      },
      flexibleBenefit: {
        label: 'Flexible benefit',
        none: 'No flexible benefit',
      },
      salary: {
        header: 'Salary History',
        amount: 'Amount',
        fromDate: 'From',
        toDate: 'To',
        isTentative: 'Salary entry is tentative',
        note: 'Note',
        workingPercentage: 'Percentage of Worktime',
        percentage: 'Percentage of Worktime',
        fulltimeSalary: 'Fulltime',
        actual: 'Actual',
        monthlySalary: '{{salary}}/month',
        monthlySalaryMinimum: 'Salary Min: {{salary}}/month',
        monthlySalaryMaximum: 'Salary Max: {{salary}}/month',
      },
      bonus: {
        header: 'Target Bonus History',
        amount: 'Amount',
        fromDate: 'From',
        toDate: 'To',
        isTentative: 'Bonus entry is tentative',
        note: 'Note',
      },
      payment: {
        header: 'Payment History',
        amount: 'Amount',
        status: 'Status',
        type: 'Type',
        paymentDate: 'Reference Year',
        paymentMonthDate: 'Payout Date',
        emptyTable: "You haven't had a payment yet.",
      },
      nationalContractLevel: {
        header: 'National Contract and Level History',
        level: 'NC - Level',
        fromDate: 'From',
        toDate: 'To',
        note: 'Note',
      },
      contractGovernmentJobTitle: {
        header: 'Government Job Title History',
        governmentJobTitle: 'Government Job Title',
        fromDate: 'From',
        toDate: 'To',
        note: 'Note',
      },
      levelHistory: {
        header: 'Level History',
        level: 'Level',
        fromDate: 'From',
        toDate: 'To',
        note: 'Note',
      },
    },
    emergencyContact: {
      name: 'Name',
      phoneNumber: 'Private Phone Number',
      emailAddress: 'E-mail',
    },
    bankAccount: {
      accountNumber: 'Account number',
      bankName: 'Bank name',
      bicSwift: 'BIC/SWIFT',
      country: 'Country',
      iban: 'IBAN',
    },
    education: {
      header: 'Education',
      grade: 'Grade',
      level: {
        header: 'Level',
        NONE: 'None',
        DIPLOMA_DEGREE: 'University Diploma',
        BACHELOR: 'Bachelor',
        MASTER: 'Master',
        PHD: 'PhD',
        APPRENTICESHIP_DEGREE: 'Apprenticeship',
        COLLEGE: 'College',
        MAGISTER: 'Magister',
        STATE_EXAMINATION: 'State examination',
        PUBLIC_OFFICIALS: 'Public officials',
      },
      title: 'Title',
      university: 'University',
      country: 'Country',
      isHighestEducation: 'Highest',
      degree: 'Degree',
      date: 'Date',
      emptyTable: "You didn't add any information about your education.",
    },
    skillCenter: {
      private: {
        header: 'My Skill',
        label: 'It seems that your skill is',
        desc: 'Go to <0>My Skill</0> to keep your skill up to date. Please, ensure it reflects your current experience and skills.',
      },
      public: {
        header: 'My Skill',
        label: {
          COMPLETED: 'Well Done',
          OUTDATED: 'Outdated',
          CV_INCOMPLETE: 'Incomplete',
          NEARLY_EXPIRING: 'Nearly outdated',
          PENDING_AI_REVIEW: 'Pending AI review',
          REQUIRES_IMPROVEMENT: 'Requires improvement',
          MISSING: 'Missing',
          UNKNOWN: 'Skill status not synced',
          UNKNOWN_YELLOW: 'Action required. Ask for assistance for further information',
          filters: {
            red: 'CV outdated',
            yellow: 'CV Needs Attention',
            green: 'CV Well Done',
            missing: 'CV missing',
          },
        },
        na: 'N.A.',
        viewStatusButton: 'View Skill status',
        refreshStatusButton: 'Refresh Skill status',
        latestSyncDate: 'The Skill status was synced from the Skill Center on {{date}}. ',
        refreshStatusButtonDescription: '<0>Click to synchronize now</0>.',
        skillStatus: 'Skill status',
        skillStatusError: 'An error occurred while loading the skill status',
        unknownIconTooltip: 'Skill status not synced. Try to update it from the section above "Skill Status Sync"',
      },
    },
    activityList: {
      privateHeader: 'My Highlights',
      publicHeader: 'Highlights',
      table: {
        header: {
          type: 'Type',
          name: 'Name',
          date: 'Date',
          link: 'Link',
        },
      },
      notifications: {
        error: {
          title: 'Error while retrieving activity list',
          description: 'An error occurred while retrieving the activity list.',
        },
      },
      errorTooltip: 'An error occurred while retrieving data.',
    },
  },
  kudos: {
    header: 'Kudos received',
    description: 'Kudos description',
    author: 'Author',
    viewDetails: 'View Details',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    of: 'of',
    loading: 'Loading kudos...',
    error: 'Error loading kudos',
    noKudos: 'No kudos received.',
    appraisalUpdate: {
      complete: "Showing kudos received in {{year}}. To view the complete list of kudos, visit <0>{{employeeName}}'s profile</0>.",
    },
    appraisal: {
      complete:
        "Showing kudos received in {{currentYear}} and {{previousYear}}. To view the complete list of kudos, visit <0>{{employeeName}}'s profile</0>.",
    },
    profileSection: {
      description:
        'In this section you can view the kudos you have received. If you wish to assign kudos to colleagues, please visit the <0>Kudos page</0>.',
      optOut: {
        tooltipButton: {
          enable: 'Start using kudos',
          disable: 'Stop using kudos',
        },
        employeeOptedOutDescription: 'Kudos are disabled for this employee at the moment.',
        privateOptedOutDescription:
          'You have opted out of receiving kudos. If you want to start receiving them again, you can re-enable this feature at any time.',
        privateOptedInDescription: 'If you prefer not to receive kudos, you can turn them off at any time.',
        modalOptOutDescription1: 'Disabling kudos removes your access to the feature.',
        modalOptOutDescription2:
          'All kudos you previously received or gave will no longer be visible. Your name will not appear in the list of employees who can receive kudos, and you will not be able to send, receive, or view kudos in any form.',
        modalOptOutDescription3: 'You can re-enable kudos at any time.',
        modalOptInDescription1: 'Re-enabling kudos restores your access to the feature.',
        modalOptInDescription2:
          'You will be able to send, receive, and view kudos again. Previously received or given kudos will become visible where applicable, and your name will appear again in the list of employees who can receive kudos.',
        modalOptOutDescriptionPublicProfile1: "Disabling kudos removes {{employee}}'s access to the feature.",
        modalOptOutDescriptionPublicProfile2:
          "All kudos they previously received or gave will no longer be visible. {{employee}}'s name will not appear in the list of employees who can receive kudos, and they will not be able to send, receive, or view kudos in any form. They can re-enable kudos at any time.",
        modalOptInDescriptionPublicProfile1: "Re-enabling kudos restores {{employee}}'s access to the feature.",
        modalOptInDescriptionPublicProfile2:
          "They will be able to send, receive, and view kudos again. Any kudos they previously received or gave will become visible where applicable, and {{employee}}'s name will appear again in the list of employees who can receive kudos.",
      },
    },
    management: {
      title: 'Kudos Management',
      createNewWithEmployee: 'Create Kudos for Employee',
      actions: 'Actions',
      dashboardReplyerDisclaimer:
        "View the Kudos you've sent. Use Kudos to show appreciation, review recognitions, and celebrate teamwork. Recipients get an automatic notification when a Kudos is sent. To see the Kudos you've personally received, visit your profile page.",
      dashboardDisclaimer:
        "View the Kudos you've sent and those your team members have received. Use Kudos to show appreciation, review recognitions, and celebrate teamwork. Recipients get an automatic notification when a Kudos is sent. To see the Kudos you've personally received, visit your profile page.",
      filters: {
        title: 'Filters',
        dateRange: 'Date Range',
        date: 'Month/Year',
        fromDate: 'From Date',
        toDate: 'To Date',
        employeeName: 'Employee',
        employeeNamePlaceholder: 'Search by employee...',
        employeeCompany: 'Employee Company',
        employeeCompanyPlaceholder: 'Search by company...',
        legalEntity: 'Legal Entity',
        company: 'Company',
        legalEntityPlaceholder: 'Search by legal entity...',
        visibility: 'Visibility',
        authorName: 'Author',
        authorNamePlaceholder: 'Search by author...',
        country: 'Employee Country',
        countryPlaceholder: 'Country',
        filterByMe: 'Filter By Me',
        showOnlyMine: 'Show kudos assigned by me',
        clear: 'Clear Filters',
      },
      tabs: {
        header: {
          dashboard: 'Dashboard',
          settingsVisibility: 'Visibility Settings',
          legalEntityVisibility: 'Legal Entity Visibility',
          companyCountryVisibility: 'Company-Country Visibility',
        },
        legalEntityVisibilityDisclaimer:
          'Kudos visibility for legal entities can be managed from this page. By default, each legal entity inherits the visibility setting defined at the country level. This value can be modified here to enable or disable kudos for the selected legal entity.',
        companyCountryVisibilityDisclaimer:
          'Kudos visibility for companies can be managed from this page. Company-country level settings act as overrides and take precedence over the visibility defined at the legal entity level. When no company-country level override is present, kudos visibility follows the legal entity configuration.',
      },
    },
    table: {
      description: 'Description',
      employee: 'Employee',
      company: 'Company',
      country: 'Country',
      author: 'Author',
      date: 'Date',
      actions: 'Actions',
      view: 'View',
      delete: 'Delete',
      edit: 'Edit',
      legalEntityName: 'Legal Entity',
      visibility: 'Visibility',
      enabled: 'Enabled',
      disabled: 'Disabled',
      noKudosWithFilters: 'No kudos found with the current filters',
      noKudosWithFiltersInfo:
        'There are no kudos to display with the current filter settings. Try adjusting your filters or create a new kudos.',
      noLegalEntityVisibilityWithFilters: 'No Legal Entity found with the current filters',
      noLegalEntityVisibilityWithFiltersInfo:
        'There are no legal entities to display with the current filter settings. Try adjusting your filters.',
      noCompanyCountryVisibilityWithFilters: 'No company-country pairs found with the current filters',
      noCompanyCountryVisibilityWithFiltersInfo:
        'There are no company-country pairs to display with the current filter settings. Try adjusting your filters.',
    },
    delete: {
      confirmTitle: 'Delete Kudos',
      confirmMessage: 'Are you sure you want to delete this kudos? This action cannot be undone.',
      error: {
        generic: 'An error occurred while deleting the kudos. Please try again.',
      },
    },
    settings: {
      switchContentDescription: 'By using the selector, you can display the kudos visibility settings for legal entities or companies.',
      editLegalEntityVisibilityModal: {
        title: 'Edit Legal Entity Visibility',
        error: 'Something went wrong while updating the kudos settings for this legal entity. Please try again.',
        enable1: 'The kudos feature is currently disabled for this legal entity.',
        enable2:
          'While disabled, employees within this legal entity cannot give or receive kudos, and previously assigned kudos will not be accessible.',
        enable3: 'Would you like to activate the kudos feature?',
        disable1: 'The kudos feature is currently enabled for this legal entity.',
        disable2:
          'Disabling this feature will prevent employees from giving or receiving kudos, and existing kudos will no longer be visible.',
        disable3: 'Are you sure you want to disable the kudos feature?',
      },
      editCompanyCountryVisibilityModal: {
        title: 'Edit Company-Country Visibility',
        error: 'Something went wrong while updating the kudos settings for this company-country pair. Please try again.',
        enable1: 'The kudos feature is currently disabled for this company-country pair.',
        enable2:
          'While disabled, employees within this company-country pair cannot give or receive kudos, and previously assigned kudos will not be accessible.',
        enable3: 'Would you like to activate the kudos feature?',
        disable1: 'The kudos feature is currently enabled for this company-country pair.',
        disable2:
          'Disabling this feature will prevent employees from giving or receiving kudos, and existing kudos will no longer be visible.',
        disable3: 'Are you sure you want to disable the kudos feature?',
      },
      deleteCompanyCountryVisibilityModal: {
        title: 'Delete Company-Country Visibility Override',
        error: 'Something went wrong while deleting the kudos settings for this company-country pair. Please try again.',
        disclaimer1: 'Are you sure you want to remove this company-country visibility override?',
        disclaimer2:
          'Once removed, employees belonging to this company and country will no longer follow this override and will inherit the kudos visibility settings defined at the legal entity level.',
      },
      createCompanyCountryVisibilityModal: {
        title: 'Override Company-Country Visibility',
        disclaimer1:
          "This configuration creates a company-country level override that takes precedence over the visibility settings defined at the legal entity level. When you create this override, all employees belonging to the selected company-country combination will use the visibility setting you configure here, regardless of their legal entity's configuration.",
        disclaimer2:
          'Once created, this override will immediately replace the legal entity configuration for all employees belonging to the selected company-country combination. To remove the override and revert to the legal entity setting, you will need to delete this configuration.',
        disclaimer3:
          '<0>Note:</0> If an override already exists for the selected company-country combination, this operation will update the existing entry rather than creating a new one.',
        error: 'Something went wrong while overriding the Kudos settings for this company-country pair. Please try again.',
        companyPlaceholder: 'Select Company',
        countryPlaceholder: 'Select Country',
        company: 'Company',
        country: 'Country',
        visibility: 'Visibility',
      },
    },
    detailsModal: {
      title: 'Kudos',
      closeButtonText: 'Got it',
    },
    createModal: {
      title: 'Create new Kudos',
      employee: 'Employee',
      employeeSearchInfo: 'The search includes all companies. Select a company to narrow the results.',
      company: 'Company (optional)',
      companyDisabled: 'Clear the selected employee to change the company.',
      disclaimer: 'Kudos are for saying thanks and celebrating great moments together — a small gesture that makes teamwork shine.',
      employeePlaceholder: 'Search employees across all companies',
      employeeWithCompanyPlaceholder: 'Search employees in {{company}}',
      description: 'Description',
      descriptionPlaceholder: 'Enter kudos description...',
      errors: {
        generic: 'An error occurred while creating the kudos. Please try again.',
      },
      forEmployee: 'Kudos for:',
      disabledButtonTooltip: 'Please fill in all required fields before posting a Kudos.',
      guidelines: {
        header: 'Before you post a Kudos:',
        description1:
          "Kudos are meant to share appreciation and say thank you to colleagues. Please keep your message respectful and professional. Do not post anything offensive, defamatory, threatening, misleading, or inappropriate, and avoid content that could harm someone's reputation, privacy, or dignity.",
        description2:
          'You are responsible for what you share. Reply does not review messages before they are published and is not liable for content posted by users. If a message is considered inappropriate, false, or in breach of these guidelines, Reply may remove it at any time at its discretion.',
        checkboxLabel: 'I have read and agree with the guidelines above.',
        tooltip: 'Please acknowledge the guidelines before posting a Kudos.',
      },
    },
    updateOptOutModal: {
      enableTitle: 'Start using kudos',
      disableTitle: 'Stop using kudos',
      confirm: 'Ok',
      error: 'An error occurred while updating kudos settings. Please try again.',
    },
    notifications: {
      updateOptOutValue: {
        enableSuccessTitle: 'Kudos Enabled',
        enableSuccessDescription: 'You can now send and receive Kudos again.',
        enableSuccessDescriptionPublicProfile: '{{employee}} can now send and receive Kudos again.',
        disableSuccessTitle: 'Kudos Disabled',
        disableSuccessDescription: 'You will no longer receive or send Kudos to your colleagues.',
        disableSuccessDescriptionPublicProfile: '{{employee}} will no longer receive or send Kudos to their colleagues.',
      },
      create: {
        successTitle: 'Kudos Created',
        successDescription: 'The kudos has been successfully created.',
      },
      delete: {
        successTitle: 'Kudos Deleted',
        successDescription: 'The kudos has been successfully deleted.',
      },
      editLegalEntityVisibility: {
        successTitle: 'Legal Entity visibility updated',
        successDescription: 'The Kudos feature configuration for this Legal Entity has been updated successfully.',
      },
      editCompanyCountryVisibility: {
        successTitle: 'Company-Country visibility updated',
        successDescription: 'The Kudos feature configuration for this Company-Country pair has been updated successfully.',
      },
      createCompanyCountryVisibility: {
        successTitle: 'Company-Country visibility override created',
        successDescription: 'The Kudos feature configuration for this Company-Country pair has been created successfully.',
      },
      deleteCompanyCountryVisibility: {
        successTitle: 'Company-Country visibility override deleted',
        successDescription: 'The Kudos feature configuration for this Company-Country pair has been deleted successfully.',
      },
    },
  },
  attentionPoint: {
    header: 'Attention points received',
    description: 'Attention point description',
    author: 'Author',
    viewDetails: 'View Details',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    of: 'of',
    loading: 'Loading attention points...',
    error: 'Error loading attention points',
    noAttentionPoints: 'No attention points received',
    management: {
      title: 'Attention Points Management',
      createNewWithEmployee: 'Create Attention Point for Employee',
      actions: 'Actions',
      dashboardDisclaimer:
        'This page displays the list of employees with active attention points and allows HR to add new ones, strictly for internal HR use only. An attention point is a non-sensitive internal note highlighting a situation that may require follow-up, and never includes confidential or sensitive personal information.',
      filters: {
        title: 'Filters',
        dateRange: 'Date Range',
        date: 'Month/Year',
        fromDate: 'From Date',
        toDate: 'To Date',
        employeeName: 'Employee',
        employeeNamePlaceholder: 'Search by employee...',
        employeeCompany: 'Employee Company',
        employeeCompanyPlaceholder: 'Search by company...',
        authorName: 'Author',
        authorNamePlaceholder: 'Search by author...',
        country: 'Employee Country',
        countryPlaceholder: 'Country',
        filterByMe: 'Filter By Me',
        showOnlyMine: 'Show attention points assigned by me',
        clear: 'Clear Filters',
      },
    },
    table: {
      description: 'Description',
      employee: 'Employee',
      company: 'Company',
      author: 'Author',
      date: 'Date',
      actions: 'Actions',
      view: 'View',
      delete: 'Delete',
      noAttentionPointsWithFilters: 'No attention points found with the current filters',
      noAttentionPointsWithFiltersInfo:
        'There are no attention points to display with the current filter settings. Try adjusting your filters or create a new attention point.',
    },
    delete: {
      confirmTitle: 'Delete Attention Point',
      confirmMessage: 'Are you sure you want to delete this attention point? This action cannot be undone.',
      error: {
        generic: 'An error occurred while deleting the attention point. Please try again.',
      },
    },
    detailsModal: {
      title: 'Attention Point',
      closeButtonText: 'Got it',
    },
    createModal: {
      title: 'Create new Attention Point',
      employee: 'Employee',
      disclaimer:
        'An attention point is a non-sensitive internal note for HR colleagues, highlighting a situation that may require follow-up. Do not include confidential or sensitive personal information.',
      employeePlaceholder: 'Search for an employee...',
      description: 'Description',
      descriptionPlaceholder: 'Enter attention point description...',
      errors: {
        generic: 'An error occurred while creating the attention point. Please try again.',
      },
      forEmployee: 'Attention Point for:',
    },
    notifications: {
      create: {
        successTitle: 'Attention Point Created',
        successDescription: 'The attention point has been successfully created.',
      },
      delete: {
        successTitle: 'Attention Point Deleted',
        successDescription: 'The attention point has been successfully deleted.',
      },
    },
  },
  contract: {
    typeOfContract: {
      APPRENTICESHIP: 'Apprenticeship',
      PROJECT_CONTRACT: 'Project contract',
      FIXED_TERM_CONTRACT: 'Fixed term contract',
      INTERNSHIP: 'Internship',
      UNLIMITED: 'Unlimited',
      AT_WILL: 'At will',
      REGULAR: 'Regular',
      WORK_EXPERIENCE: 'Work experience',
      ZERO_HOUR_CONTRACT: 'Zero hour contract',
      ADMINISTRATOR: 'Administrator',
    },
    cancellationType: {
      EMPLOYEE_TERMINATION: 'Employee termination',
      EMPLOYER_TERMINATION: 'Employer termination',
      EMPLOYEE_TERMINATION_IN_PROBATION: 'Employee termination in probation',
      EMPLOYER_TERMINATION_IN_PROBATION: 'Employer termination in probation',
      ABOLITION_TREATMENT: 'Abolition treatment',
      ABOLITION_TREATMENT_EMPLOYEE: 'Abolition treatment employee',
      PENSION: 'Pension',
      TEMPORARY_CONTRACT: 'Temporary contract',
      INTERNAL_CHANGE: 'Internal change',
      DEATH: 'Death',
      UNKNOWN: 'Unknown',
    },
  },
  nextMeetingTile: {
    noMeetingScheduled: 'Looks like no meeting is scheduled for you.',
    noMeetingScheduledEmployee: 'Looks like no meeting is scheduled for {{employee}}.',
    noMeetingScheduledManager: 'Looks like you have no scheduled meetings.',
  },
  global: {
    you: 'You',
    disclaimer: {
      title: 'Important notice',
      description:
        'Due to yearly maintenance activities you might experience some delay with data synchronization across the HR systems. We apologize for any inconvenience this may cause and appreciate your understanding.',
    },
    button: {
      ok: 'Ok',
      confirm: 'Confirm',
      save: 'Save',
      duplicateAndDismiss: 'Duplicate and dismiss',
      duplicateAndDelete: 'Duplicate and delete',
      cancel: 'Cancel',
      delete: 'Delete',
      close: 'Close',
      export: 'Export',
      import: 'Import',
      apply: 'Apply',
      applyFilter: 'Apply filter',
      edit: 'Edit',
      accept: 'Accept',
      decline: 'Decline',
      isProcessing: {
        processing: 'Processing',
        saving: 'Saving',
        confirming: 'Confirming',
      },
    },
    yes: 'Yes',
    no: 'No',
    showMore: 'Show more',
    viewMore: 'View more',
    meetingType: 'Meeting type',
    today: 'today',
    from: 'From',
    to: 'To',
    month: {
      0: 'January',
      1: 'February',
      2: 'March',
      3: 'April',
      4: 'May',
      5: 'June',
      6: 'July',
      7: 'August',
      8: 'September',
      9: 'October',
      10: 'November',
      11: 'December',
      12: 'January',
      13: 'February',
      14: 'March',
    },
    country: {
      AFG: 'Afghanistan',
      ALA: 'Åland Islands',
      ALB: 'Albania',
      DZA: 'Algeria',
      AND: 'Andorra',
      AGO: 'Angola',
      AIA: 'Anguilla',
      ATG: 'Antigua and Barbuda',
      ARG: 'Argentina',
      ARM: 'Armenia',
      ASM: 'American Samoa',
      ATA: 'Antarctica',
      ABW: 'Aruba',
      AUS: 'Australia',
      AUT: 'Austria',
      AZE: 'Azerbaijan',
      BHS: 'Bahamas',
      BHR: 'Bahrain',
      BGD: 'Bangladesh',
      BRB: 'Barbados',
      BLR: 'Belarus',
      BEL: 'Belgium',
      BLZ: 'Belize',
      BEN: 'Benin',
      BMU: 'Bermuda',
      BTN: 'Bhutan',
      BOL: 'Bolivia (Plurinational State of)',
      BES: 'Bonaire, Sint Eustatius and Saba	',
      BIH: 'Bosnia and Herzegovina',
      BWA: 'Botswana',
      BVT: 'Bouvet Island',
      BRA: 'Brazil',
      IOT: 'British Indian Ocean Territory',
      VGB: 'British Virgin Islands',
      BRN: 'Brunei Darussalam',
      BGR: 'Bulgaria',
      BFA: 'Burkina Faso',
      BDI: 'Burundi',
      CPV: 'Cabo Verde',
      KHM: 'Cambodia',
      CMR: 'Cameroon',
      CAN: 'Canada',
      CYM: 'Cayman Islands',
      CAF: 'Central African Republic',
      TCD: 'Chad',
      CHL: 'Chile',
      CHN: 'China',
      HKG: 'China, Hong Kong Special Administrative Region',
      MAC: 'China, Macao Special Administrative Region',
      CXR: 'Christmas Island',
      CCK: 'Cocos (Keeling) Islands',
      COL: 'Colombia',
      COM: 'Comoros',
      COG: 'Congo',
      COK: 'Cook Islands',
      CRI: 'Costa Rica',
      CIV: 'Côte d’Ivoire',
      HRV: 'Croatia',
      CUB: 'Cuba',
      CUW: 'Curaçao',
      CYP: 'Cyprus',
      CZE: 'Czechia',
      PRK: "Democratic People's Republic of Korea",
      COD: 'Democratic Republic of the Congo',
      DNK: 'Denmark',
      DJI: 'Djibouti',
      DMA: 'Dominica',
      DOM: 'Dominican Republic',
      ECU: 'Ecuador',
      EGY: 'Egypt',
      SLV: 'El Salvador',
      GNQ: 'Equatorial Guinea',
      ERI: 'Eritrea',
      EST: 'Estonia',
      SWZ: 'Eswatini',
      ETH: 'Ethiopia',
      FLK: 'Falkland Islands (Malvinas)',
      FRO: 'Faroe Islands',
      FJI: 'Fiji',
      FIN: 'Finland',
      FRA: 'France',
      GUF: 'French Guiana',
      PYF: 'French Polynesia',
      ATF: 'French Southern Territories',
      GAB: 'Gabon',
      GMB: 'Gambia',
      GEO: 'Georgia',
      DEU: 'Germany',
      GHA: 'Ghana',
      GIB: 'Gibraltar',
      GRC: 'Greece',
      GRL: 'Greenland',
      GRD: 'Grenada',
      GLP: 'Guadeloupe',
      GUM: 'Guam',
      GTM: 'Guatemala',
      GGY: 'Guernsey',
      GIN: 'Guinea',
      GNB: 'Guinea-Bissau',
      GUY: 'Guyana',
      HTI: 'Haiti',
      HMD: 'Heard Island and McDonald Islands',
      VAT: 'Holy See',
      HND: 'Honduras',
      HUN: 'Hungary',
      ISL: 'Iceland',
      IND: 'India',
      IDN: 'Indonesia',
      IRN: 'Iran (Islamic Republic of)',
      IRQ: 'Iraq',
      IRL: 'Ireland',
      IMN: 'Isle of Man',
      ISR: 'Israel',
      ITA: 'Italy',
      JAM: 'Jamaica',
      JPN: 'Japan',
      JEY: 'Jersey',
      JOR: 'Jordan',
      KAZ: 'Kazakhstan',
      KEN: 'Kenya',
      KIR: 'Kiribati',
      KWT: 'Kuwait',
      KGZ: 'Kyrgyzstan',
      LAO: "Lao People's Democratic Republic",
      LVA: 'Latvia',
      LBN: 'Lebanon',
      LSO: 'Lesotho',
      LBR: 'Liberia',
      LBY: 'Libya',
      LIE: 'Liechtenstein',
      LTU: 'Lithuania',
      LUX: 'Luxembourg',
      MDG: 'Madagascar',
      MWI: 'Malawi',
      MYS: 'Malaysia',
      MDV: 'Maldives',
      MLI: 'Mali',
      MLT: 'Malta',
      MHL: 'Marshall Islands',
      MTQ: 'Martinique',
      MRT: 'Mauritania',
      MUS: 'Mauritius',
      MYT: 'Mayotte',
      MEX: 'Mexico',
      FSM: 'Micronesia (Federated States of)',
      MCO: 'Monaco',
      MNG: 'Mongolia',
      MNE: 'Montenegro',
      MSR: 'Montserrat',
      MAR: 'Morocco',
      MOZ: 'Mozambique',
      MMR: 'Myanmar',
      NAM: 'Namibia',
      NRU: 'Nauru',
      NPL: 'Nepal',
      NLD: 'Netherlands',
      NCL: 'New Caledonia',
      NZL: 'New Zealand',
      NIC: 'Nicaragua',
      NER: 'Niger',
      NGA: 'Nigeria',
      NIU: 'Niue',
      NFK: 'Norfolk Island',
      MKD: 'North Macedonia',
      MNP: 'Northern Mariana Islands',
      NOR: 'Norway',
      OMN: 'Oman',
      PAK: 'Pakistan',
      PLW: 'Palau',
      PAN: 'Panama',
      PNG: 'Papua New Guinea',
      PRY: 'Paraguay',
      PER: 'Peru',
      PHL: 'Philippines',
      PCN: 'Pitcairn',
      POL: 'Poland',
      PRT: 'Portugal',
      PRI: 'Puerto Rico',
      QAT: 'Qatar',
      KOR: 'Republic of Korea',
      MDA: 'Republic of Moldova',
      REU: 'Réunion',
      ROU: 'Romania',
      RUS: 'Russian Federation',
      RWA: 'Rwanda',
      BLM: 'Saint Barthélemy',
      SHN: 'Saint Helena',
      KNA: 'Saint Kitts and Nevis',
      LCA: 'Saint Lucia',
      MAF: 'Saint Martin (French Part)',
      SPM: 'Saint Pierre and Miquelon',
      VCT: 'Saint Vincent and the Grenadines',
      WSM: 'Samoa',
      SMR: 'San Marino',
      STP: 'Sao Tome and Principe',
      // ???: 'Sark',
      SAU: 'Saudi Arabia',
      SEN: 'Senegal',
      SRB: 'Serbia',
      SYC: 'Seychelles',
      SLE: 'Sierra Leone',
      SGP: 'Singapore',
      SXM: 'Sint Maarten (Dutch part)',
      SVK: 'Slovakia',
      SVN: 'Slovenia',
      SLB: 'Solomon Islands',
      SOM: 'Somalia',
      ZAF: 'South Africa',
      SGS: 'South Georgia and the South Sandwich Islands',
      SSD: 'South Sudan',
      ESP: 'Spain',
      LKA: 'Sri Lanka',
      PSE: 'State of Palestine',
      SDN: 'Sudan',
      SUR: 'Suriname',
      SJM: 'Svalbard and Jan Mayen Islands',
      SWE: 'Sweden',
      CHE: 'Switzerland',
      SYR: 'Syrian Arab Republic',
      TJK: 'Tajikistan',
      THA: 'Thailand',
      TLS: 'Timor-Leste',
      TGO: 'Togo',
      TKL: 'Tokelau',
      TON: 'Tonga',
      TTO: 'Trinidad and Tobago',
      TUN: 'Tunisia',
      TUR: 'Turkey',
      TKM: 'Turkmenistan',
      TCA: 'Turks and Caicos Islands',
      TUV: 'Tuvalu',
      UGA: 'Uganda',
      UKR: 'Ukraine',
      ARE: 'United Arab Emirates',
      GBR: 'United Kingdom of Great Britain and Northern Ireland',
      TZA: 'United Republic of Tanzania',
      UMI: 'United States Minor Outlying Islands',
      USA: 'United States of America',
      VIR: 'United States Virgin Islands',
      URY: 'Uruguay',
      UZB: 'Uzbekistan',
      VUT: 'Vanuatu',
      VEN: 'Venezuela (Bolivarian Republic of)',
      VNM: 'Viet Nam',
      WLF: 'Wallis and Futuna Islands',
      ESH: 'Western Sahara',
      XKX: 'Kosovo',
      YEM: 'Yemen',
      ZMB: 'Zambia',
      ZWE: 'Zimbabwe',
    },
    countryAbbreviation: {
      GBR: 'UK',
      USA: 'USA',
    },
    citizenship: {
      AFG: 'Afghan',
      ALA: 'Ålandish',
      ALB: 'Albanian',
      DZA: 'Algerian',
      ASM: 'American Samoan',
      AND: 'Andorran',
      AGO: 'Angolan',
      AIA: 'Anguillian',
      ATA: 'Citizen of Antarctica',
      ATG: 'Citizen of Antigua and Barbuda',
      ARG: 'Argentinian',
      ARM: 'Armenian',
      ABW: 'Aruban',
      AUS: 'Australian',
      AUT: 'Austrian',
      AZE: 'Azerbaijani',
      BHS: 'Bahamian',
      BHR: 'Bahraini',
      BGD: 'Bangladeshi',
      BRB: 'Barbadian',
      BLR: 'Belarusian',
      BEL: 'Belgian',
      BLZ: 'Belizean',
      BEN: 'Beninese',
      BMU: 'Bermudian',
      BTN: 'Bhutanese',
      BOL: 'Bolivian',
      BES: 'Citizen of Bonaire, Sint Eustatius and Saba',
      BIH: 'Bosnian and Herzegovinian',
      BWA: 'Botswanan',
      BVT: 'Citizen of Bouvet Island',
      BRA: 'Brazilian',
      IOT: 'British (Indian Ocean Territory)',
      VGB: 'British (Virgin Islands)',
      BRN: 'Bruneian',
      BGR: 'Bulgarian',
      BFA: 'Burkinabés',
      BDI: 'Burundian',
      CPV: 'Cabo Verde',
      KHM: 'Cambodian',
      CMR: 'Cameroonian',
      CAN: 'Canadian',
      CYM: 'Caymanian',
      CAF: 'Central African',
      TCD: 'Chadian',
      CHL: 'Chilean',
      CHN: 'Chinese',
      HKG: 'Chinese - Hong Kong Special Administrative Region',
      MAC: 'Chinese - Macao Special Administrative Region',
      CXR: 'Citizen of Christmas Island',
      CCK: 'Citizen of Cocos (Keeling) Islands',
      COL: 'Colombian',
      COM: 'Comorian',
      COG: 'Congolese',
      COK: 'Citizen of Cook Islands',
      CRI: 'Costa Rican',
      CIV: 'Ivorian',
      HRV: 'Croatian',
      CUB: 'Cuban',
      CUW: 'Citizen of Curaçao',
      CYP: 'Citizen of Cyprus',
      CZE: 'Czech',
      PRK: 'Korean',
      COD: 'Congolese',
      DNK: 'Danish',
      DJI: 'Djiboutian',
      DMA: 'Dominican (Commonwealth)',
      DOM: 'Dominican (Republic)',
      ECU: 'Ecuadorian',
      EGY: 'Egyptian',
      SLV: 'Salvadoran',
      GNQ: 'Equatorial Guinean',
      ERI: 'Eritrean',
      EST: 'Estonian',
      SWZ: 'Eswatinian',
      ETH: 'Ethiopian',
      FLK: 'Citizen of Falkland Islands (Malvinas)',
      FRO: 'Faroese',
      FJI: 'Fijian',
      FIN: 'Finish',
      FRA: 'French',
      GUF: 'French - Guiana',
      PYF: 'French - Polynesia',
      ATF: 'French - Southern Territories',
      GAB: 'Gabonese',
      GMB: 'Gambian',
      GEO: 'Georgian',
      DEU: 'German',
      GHA: 'Ghanaian',
      GIB: 'Gibraltarian',
      GRC: 'Greek',
      GRL: 'Greenlandic',
      GRD: 'Grenadian',
      GLP: 'Guadeloupean',
      GUM: 'Guamanian',
      GTM: 'Guatemalan',
      GGY: 'Citizen of Guernsey',
      GIN: 'Guineaan',
      GNB: 'Citizen of Guinea-Bissau',
      GUY: 'Guyanese',
      HTI: 'Haitian',
      HMD: 'Citizen of Heard Island and McDonald Islands',
      VAT: 'Citizen of Holy See',
      HND: 'Honduran',
      HUN: 'Hungarian',
      ISL: 'Icelandic',
      IND: 'Indian',
      IDN: 'Indonesian',
      IRN: 'Iranian',
      IRQ: 'Iraqi',
      IRL: 'Irish',
      IMN: 'Citizen of Isle of Man',
      ISR: 'Israeli',
      ITA: 'Italian',
      JAM: 'Jamaican',
      JPN: 'Japanese',
      JEY: 'Citizen of Jersey',
      JOR: 'Jordanian',
      KAZ: 'Kazakhstani',
      KEN: 'Kenyan',
      KIR: 'Kiribati',
      KWT: 'Kuwaiti',
      KGZ: 'Kyrgyzstani',
      LAO: 'Laotian',
      LVA: 'Latvian',
      LBN: 'Lebanese',
      LSO: 'Citizen of Lesotho',
      LBR: 'Liberian',
      LBY: 'Libyan',
      LIE: 'Citizen of Liechtenstein',
      LTU: 'Lithuanian',
      LUX: 'Citizen of Luxembourg',
      MDG: 'Malagasy',
      MWI: 'Malawian',
      MYS: 'Malaysian',
      MDV: 'Maldivian',
      MLI: 'Malian',
      MLT: 'Maltese',
      MHL: 'Marshallese',
      MTQ: 'Martinican',
      MRT: 'Mauritanian',
      MUS: 'Mauritian',
      MYT: 'Mahoran',
      MEX: 'Mexican',
      FSM: 'Micronesian',
      MCO: 'Monacan',
      MNG: 'Mongolian',
      MNE: 'Montenegrian',
      MSR: 'Montserratian',
      MAR: 'Moroccans',
      MOZ: 'Mozambican',
      MMR: 'Citizen of Myanmar',
      NAM: 'Namibian',
      NRU: 'Nauruan',
      NPL: 'Nepalese',
      NLD: 'Citizen of Netherlands',
      NCL: 'New Caledonian',
      NZL: 'Citizen of New Zealand',
      NIC: 'Nicaraguan',
      NER: 'Nigerien',
      NGA: 'Nigerian',
      NIU: 'Citizen of Niue',
      NFK: 'Citizen of Norfolk Island',
      MKD: 'North Macedonian',
      MNP: 'Citizen of Northern Mariana Islands',
      NOR: 'Norwegian',
      OMN: 'Omani',
      PAK: 'Pakistani',
      PLW: 'Palauan',
      PAN: 'Panamanian',
      PNG: 'Papua New Guinean',
      PRY: 'Paraguayan',
      PER: 'Peruvian',
      PHL: 'Philippines',
      PCN: 'Citizen of Pitcairn',
      POL: 'Polish',
      PRT: 'Portuguese',
      PRI: 'Puerto Rican',
      QAT: 'Qatari',
      KOR: 'Korean',
      MDA: 'Moldovan',
      REU: 'Réunionese',
      ROU: 'Romanian',
      RUS: 'Russian',
      RWA: 'Rwandan',
      BLM: 'Citizen of Saint Barthélemy',
      SHN: 'Citizen of Saint Helena',
      KNA: 'Citizen of Saint Kitts and Nevis',
      LCA: 'Citizen of Saint Lucia',
      MAF: 'Citizen of Saint Martin (French Part)',
      SPM: 'Pierrian',
      VCT: 'Saint Vincentian',
      WSM: 'Samoan',
      SMR: 'San Marino',
      STP: 'Sao Tome and Principe',
      SAU: 'Saudi Arabian',
      SEN: 'Senegalese',
      SRB: 'Serbian',
      SYC: 'Citizen of Seychelles',
      SLE: 'Sierra Leonean',
      SGP: 'Singaporean',
      SXM: 'Citizen of Sint Maarten (Dutch part)',
      SVK: 'Slovakian',
      SVN: 'Slovenian',
      SLB: 'Citizen of Solomon Islands',
      SOM: 'Somalian',
      ZAF: 'South African',
      SGS: 'Citizen of South Georgia and the South Sandwich Islands',
      SSD: 'South Sudanese',
      ESP: 'Spanish',
      LKA: 'Citizen of Sri Lanka',
      PSE: 'Palestinian',
      SDN: 'Sudanese',
      SUR: 'Surinamese',
      SJM: 'Citizen of Svalbard and Jan Mayen Islands',
      SWE: 'Swedish',
      CHE: 'Swiss',
      SYR: 'Syrian',
      TJK: 'Tajik',
      THA: 'Thai',
      TLS: 'Citizen of Timor-Leste',
      TGO: 'Togolese',
      TKL: 'Citizen of Tokelau',
      TON: 'Tongan',
      TTO: 'Trinidadian',
      TUN: 'Tunisian',
      TUR: 'Turkish',
      TKM: 'Turkmenistani',
      TCA: 'Citizen of Turks and Caicos Islands',
      TUV: 'Tuvaluan',
      UGA: 'Ugandan',
      UKR: 'Ukrainian',
      ARE: 'Emirati',
      GBR: 'British',
      TZA: 'Tanzanian',
      UMI: 'Citizen of United States Minor Outlying Islands',
      USA: 'American',
      VIR: 'Citizen of United States Virgin Islands',
      URY: 'Uruguayan',
      UZB: 'Uzbeki',
      VUT: 'Vanuatuan',
      VEN: 'Venezuelan',
      VNM: 'Vietnamese',
      WLF: 'Citizen of Wallis and Futuna Islands',
      ESH: 'Citizen of Western Sahara',
      XKX: 'Kosovoian',
      YEM: 'Yemenis',
      ZMB: 'Zambian',
      ZWE: 'Zimbabwean',
    },
    language: {
      ab: 'Abkhazian',
      aa: 'Afar',
      af: 'Afrikaans',
      sq: 'Albanian',
      am: 'Amharic',
      ar: 'Arabic',
      hy: 'Armenian',
      as: 'Assamese',
      ay: 'Aymara',
      az: 'Azerbaijani',
      ba: 'Bashkir',
      eu: 'Basque',
      bn: 'Bengali, Bangla',
      dz: 'Bhutani',
      bh: 'Bihari',
      bi: 'Bislama',
      br: 'Breton',
      bg: 'Bulgarian',
      my: 'Burmese',
      be: 'Byelorussian',
      km: 'Cambodian',
      ca: 'Catalan',
      zh: 'Chinese',
      co: 'Corsican',
      hr: 'Croatian',
      cs: 'Czech',
      da: 'Danish',
      nl: 'Dutch',
      en: 'English',
      eo: 'Esperanto',
      et: 'Estonian',
      fo: 'Faeroese',
      fj: 'Fiji',
      fi: 'Finnish',
      fr: 'French',
      fy: 'Frisian',
      gd: 'Gaelic (Scots Gaelic)',
      gl: 'Galician',
      ka: 'Georgian',
      de: 'German',
      el: 'Greek',
      kl: 'Greenlandic',
      gn: 'Guarani',
      gu: 'Gujarati',
      ha: 'Hausa',
      iw: 'Hebrew',
      hi: 'Hindi',
      hu: 'Hungarian',
      is: 'Icelandic',
      in: 'Indonesian',
      ia: 'Interlingua',
      ie: 'Interlingue',
      ik: 'Inupiak',
      ga: 'Irish',
      it: 'Italian',
      ja: 'Japanese',
      jw: 'Javanese',
      kn: 'Kannada',
      ks: 'Kashmiri',
      kk: 'Kazakh',
      rw: 'Kinyarwanda',
      ky: 'Kirghiz',
      rn: 'Kirundi',
      ko: 'Korean',
      ku: 'Kurdish',
      lo: 'Laothian',
      la: 'Latin',
      lv: 'Latvian, Lettish',
      ln: 'Lingala',
      lt: 'Lithuanian',
      mk: 'Macedonian',
      mg: 'Malagasy',
      ms: 'Malay',
      ml: 'Malayalam',
      mt: 'Maltese',
      mi: 'Maori',
      mr: 'Marathi',
      mo: 'Moldavian',
      mn: 'Mongolian',
      na: 'Nauru',
      ne: 'Nepali',
      no: 'Norwegian',
      oc: 'Occitan',
      or: 'Oriya',
      om: 'Oromo, Afan',
      ps: 'Pashto, Pushto',
      fa: 'Persian',
      pl: 'Polish',
      pt: 'Portuguese',
      pa: 'Punjabi',
      qu: 'Quechua',
      rm: 'Rhaeto-Romance',
      ro: 'Romanian',
      ru: 'Russian',
      sm: 'Samoan',
      sg: 'Sangro',
      sa: 'Sanskrit',
      sr: 'Serbian',
      sh: 'Serbo-Croatian',
      st: 'Sesotho',
      tn: 'Setswana',
      sn: 'Shona',
      sd: 'Sindhi',
      si: 'Singhalese',
      ss: 'Siswati',
      sk: 'Slovak',
      sl: 'Slovenian',
      so: 'Somali',
      es: 'Spanish',
      su: 'Sudanese',
      sw: 'Swahili',
      sv: 'Swedish',
      tl: 'Tagalog',
      tg: 'Tajik',
      ta: 'Tamil',
      tt: 'Tatar',
      te: 'Tegulu',
      th: 'Thai',
      bo: 'Tibetan',
      ti: 'Tigrinya',
      to: 'Tonga',
      ts: 'Tsonga',
      tr: 'Turkish',
      tk: 'Turkmen',
      tw: 'Twi',
      uk: 'Ukrainian',
      ur: 'Urdu',
      uz: 'Uzbek',
      vi: 'Vietnamese',
      vo: 'Volapuk',
      cy: 'Welsh',
      wo: 'Wolof',
      xh: 'Xhosa',
      ji: 'Yiddish',
      yo: 'Yoruba',
      zu: 'Zulu',
    },
    gender: {
      MALE: 'Male',
      FEMALE: 'Female',
      NEUTRAL: 'Neutral',
      DIVERSE: 'Diverse',
      UNDECLARED: 'Undeclared',
    },
    roleNames: {
      GLOBAL_ADMIN: 'Global Admin',
      ADMIN: 'Admin',
      CEO: 'Ceo',
      CLUSTER_MANAGER: 'Cluster Manager',
      NETWORK_MANAGER: 'Network Manager',
      PARTNER: 'Partner',
      COMPANY_MANAGER: 'Company Manager',
      BU_MANAGER: 'Businessunit Manager',
      REVIEWER: 'Reviewer',
      REPLYER: 'Replyer',
      HR: 'Hr',
      HR_ADMIN_DEU: 'Hr Admin DEU',
      HR_READONLY_DEU: 'Hr Readonly DEU',
      HR_RESTRICTED_DEU: 'Hr Restricted DEU',
      HR_ADMIN_ITA: 'Hr Admin ITA',
      HR_READONLY_ITA: 'Hr Readonly ITA',
      HR_RESTRICTED_ITA: 'Hr Restricted ITA',
      HR_ADMIN_FRA: 'Hr Admin FRA',
      HR_READONLY_FRA: 'Hr Readonly FRA',
      HR_RESTRICTED_FRA: 'Hr Restricted FRA',
      HR_ADMIN_MAR: 'Hr Admin MAR',
      HR_READONLY_MAR: 'Hr Readonly MAR',
      HR_RESTRICTED_MAR: 'Hr Restricted MAR',
      HR_ADMIN_HRV: 'Hr Admin HRV',
      HR_READONLY_HRV: 'Hr Readonly HRV',
      HR_RESTRICTED_HRV: 'Hr Restricted HRV',
      HR_ADMIN_BEL: 'Hr Admin BEL',
      HR_READONLY_BEL: 'Hr Readonly BEL',
      HR_RESTRICTED_BEL: 'Hr Restricted BEL',
      HR_ADMIN_NLD: 'Hr Admin NLD',
      HR_READONLY_NLD: 'Hr Readonly NLD',
      HR_RESTRICTED_NLD: 'Hr Restricted NLD',
      HR_ADMIN_AUT: 'Hr Admin AUT',
      HR_READONLY_AUT: 'Hr Readonly AUT',
      HR_RESTRICTED_AUT: 'Hr Restricted AUT',
      HR_ADMIN_IND: 'Hr Admin IND',
      HR_READONLY_IND: 'Hr Readonly IND',
      HR_RESTRICTED_IND: 'Hr Restricted IND',
      HR_ADMIN_CHN: 'Hr Admin CHN',
      HR_READONLY_CHN: 'Hr Readonly CHN',
      HR_RESTRICTED_CHN: 'Hr Restricted CHN',
      HR_ADMIN_BLR: 'Hr Admin BLR',
      HR_READONLY_BLR: 'Hr Readonly BLR',
      HR_RESTRICTED_BLR: 'Hr Restricted BLR',
      HR_ADMIN_BRA: 'Hr Admin BRA',
      HR_READONLY_BRA: 'Hr Readonly BRA',
      HR_RESTRICTED_BRA: 'Hr Restricted BRA',
      HR_ADMIN_HKG: 'Hr Admin HKG',
      HR_READONLY_HKG: 'Hr Readonly HKG',
      HR_RESTRICTED_HKG: 'Hr Restricted HKG',
      HR_ADMIN_LUX: 'Hr Admin LUX',
      HR_READONLY_LUX: 'Hr Readonly LUX',
      HR_RESTRICTED_LUX: 'Hr Restricted LUX',
      HR_ADMIN_NZL: 'Hr Admin NZL',
      HR_READONLY_NZL: 'Hr Readonly NZL',
      HR_RESTRICTED_NZL: 'Hr Restricted NZL',
      HR_ADMIN_POL: 'Hr Admin POL',
      HR_READONLY_POL: 'Hr Readonly POL',
      HR_RESTRICTED_POL: 'Hr Restricted POL',
      HR_ADMIN_ROU: 'Hr Admin ROU',
      HR_READONLY_ROU: 'Hr Readonly ROU',
      HR_RESTRICTED_ROU: 'Hr Restricted ROU',
      HR_ADMIN_CHE: 'Hr Admin CHE',
      HR_READONLY_CHE: 'Hr Readonly CHE',
      HR_RESTRICTED_CHE: 'Hr Restricted CHE',
      HR_ADMIN_USA: 'Hr Admin USA',
      HR_READONLY_USA: 'Hr Readonly USA',
      HR_RESTRICTED_USA: 'Hr Restricted USA',
    },
    employeeTags: {
      general: {
        TOP: 'TOP',
        LOW: 'LOW',
        ENTRY_LEVEL_LOW: 'LOW',
        SALES: 'Sales',
        SPEAKER: 'Speaker',
        COACH: 'Coach',
        EXPERT: 'Expert',
        RISK_OF_LOSS_VERY_HIGH: 'Very High Risk of Loss',
        RISK_OF_LOSS_HIGH: 'High Risk of Loss',
        RISK_OF_LOSS_MEDIUM: 'Medium Risk of Loss',
        RISK_OF_LOSS_LOW: 'Low Risk of Loss',
        IMPACT_OF_LOSS_CRITICAL: 'Critical Impact of Loss',
        IMPACT_OF_LOSS_SIGNIFICANT: 'Significant Impact of Loss',
        IMPACT_OF_LOSS_MODERATE: 'Moderate Impact of Loss',
        IMPACT_OF_LOSS_MINOR: 'Minor Impact of Loss',
        LEAVER: 'Leaver',
        LIMITED: 'Limited',
        untagged: 'Untagged',
        unassigned: 'Unassigned',
      },
      riskOfLoss: {
        RISK_OF_LOSS_VERY_HIGH: 'Very High',
        RISK_OF_LOSS_HIGH: 'High',
        RISK_OF_LOSS_MEDIUM: 'Medium',
        RISK_OF_LOSS_LOW: 'Low',
        untagged: 'Untagged',
      },
      impactOfLoss: {
        IMPACT_OF_LOSS_CRITICAL: 'Critical',
        IMPACT_OF_LOSS_SIGNIFICANT: 'Significant',
        IMPACT_OF_LOSS_MODERATE: 'Moderate',
        IMPACT_OF_LOSS_MINOR: 'Minor',
        untagged: 'Untagged',
      },
      performance: {
        TOP: 'Top',
        LOW: 'Low',
        ENTRY_LEVEL_LOW: 'Low',
        SALES: 'Sales',
        SPEAKER: 'Speaker',
        COACH: 'Coach',
        EXPERT: 'Expert',
        untagged: 'Untagged',
      },
      notifications: {
        title: 'Tag added',
        description: 'Tag "{{tagType}}" successfully added to {{employeeName}}.',
      },
    },
    careerPath: {
      label: 'Careerpath',
      evaluation: {
        INLINE: 'Inline',
        OUT_OF_LINE: 'Out of line',
        SEMI_INLINE: 'Semi inline',
      },
      type: {
        bonusEvaluation: 'Bonus',
        salaryEvaluation: 'Salary',
        summary: 'Total',
      },
      description: {
        text: 'careerpath',
        INLINE: 'is inline.',
        OUT_OF_LINE: 'is out of line.',
        SEMI_INLINE: 'is inline in total, but out of line with salary or bonus',
        notFound: 'not found',
      },
      popover: {
        current: 'Current({{currency}})',
        reference: 'Reference(k{{currency}})',
      },
    },
    employeeCompanyRelation: {
      active: 'Active',
      resigned: 'Resigned',
      noResignedEmployees: 'No employees resigned',
    },
    employeeCancellationType: {
      EMPLOYEE_TERMINATION: 'Employee Termination',
      EMPLOYER_TERMINATION: 'Employer Termination',
      EMPLOYEE_TERMINATION_IN_PROBATION: 'Employee Termination in Probation',
      EMPLOYER_TERMINATION_IN_PROBATION: 'Employer Termination in Probation',
      ABOLITION_TREATMENT: 'Abolition Treatment',
      ABOLITION_TREATMENT_EMPLOYEE: 'Abolition treatment employee',
      PENSION: 'Pension',
      TEMPORARY_CONTRACT: 'Temporary Contract',
      INTERNAL_CHANGE: 'Internal Change',
      DEATH: 'Death',
      UNKNOWN: 'Unknown',
    },
    notifications: {
      error: {
        title: 'Error',
        description: 'An error occurred. Please, try again.',
      },
    },
  },
  datePicker: {
    placeholder: 'Select day',
  },
  monthPicker: {
    placeholder: 'Select month',
  },
  timePicker: {
    placeholder: 'Select time',
  },
  errors: {
    error: 'Error',
    employee: {
      subordinates: 'Could not retrieve subordinates',
    },
  },
  forceConfirmationModal: {
    heading: 'Force Meeting Confirmation',
    description: "Are you sure you want to close {{employeeFirstName}}'s meeting?",
    description2:
      "Partners, HR, {{employeeFirstName}} and {{employeeFirstName}}'s BU managers will be informed about the closure via email.",
    selectReason: 'Select reason',
    parentalLeave: 'Parental leave',
    longtermSickness: 'Long-term sickness',
    sabbatical: 'Sabbatical',
    leaveOfAbsence: 'Leave of absence',
    other: 'Other',
    reasonTooltip: 'Please select a reason',
    placeholder:
      'Enter the reason for forcing the confirmation of the meeting. Please, be aware that this reason will be shared in the notification email.',
    notifications: {
      success: {
        title: 'Success',
        description: 'Meeting successfully force confirmed.',
      },
    },
  },
  appraisalStatusModal: {
    employee: 'Employee',
    reviewer: 'Reviewer',
    prepared: 'Prepared',
    notPrepared: 'Not prepared',
    title: 'Current appraisal status',
    updateTitle: 'Current update appraisal status',
    statusOverview: 'Status overview',
    overview: 'Overview',
    selfReflection: 'Self reflection',
    evaluation: 'Evaluation',
    pastTargets: 'Past targets',
    payment: 'Payment',
    contractChanges: 'Employment changes',
    newTargets: 'New targets',
    achievedTargets: 'Achieved targets',
    manualDeduction: 'Manual deduction',
    oneOffPayment: 'One-off payment',
    targetCorrectionPayment: 'Target correction payment',
    toBePaid: 'To be paid',
    tooltip: 'View current appraisal status',
    modalSubheading: '{{reviewer}} invited {{employee}}',
    iconTooltipEmployee: '{{name}} - Employee',
    iconTooltipReviewer: '{{name}} - Reviewer',
    iconTooltipMeeting: 'Meeting',
    unknownConversionRate:
      'Currency for current contract is {{currentContractCurrency}}. No conversion rate found for these currencies: {{unknownCurrencies}}',
  },
  targetModal: {
    target: 'Target',
    newTarget: 'New target',
    newPastTarget: 'New past target',
    pastTarget: 'Past target',
    viewTarget: 'View target',
    editTarget: 'Edit target',
    editNewTarget: 'Edit new target',
    editPastTarget: 'Edit past target',
    targetSuggestion: 'Suggest new target',
    editTargetSuggestion: 'Edit target suggestion',
    delete: 'Delete target',
    deleteDescription: 'Are you sure you want to delete this target?',
    duplicateAndDismiss: 'Duplicate and dismiss target',
    duplicateAndDelete: 'Duplicate and delete target',
    editPaymentTarget: 'Edit payment target',
    title: 'Title',
    titlePlaceholder: 'Insert target title',
    tasks: 'Tasks',
    deleteModalTaskCheckboxTooltip: 'No changes can be done while deleting the target.',
    taskCheckboxTooltip: 'This is a step needed to achieve the target. Flag this task only if completed.',
    totalOfCharInTasks: 'Total of characters for all tasks',
    taskPlaceholder: 'Create new task',
    notes: 'Notes',
    notesPlaceholder: 'Leave a note',
    targetDetails: 'Target details',
    attachment: 'Attachment',
    development: 'Development',
    developmentTarget: 'Development target',
    monetary: 'Monetary',
    monetaryTarget: 'Monetary Target',
    startDate: 'Start date',
    dueDate: 'Due date',
    targetAmount: 'Target amount',
    achievedAmount: 'Achieved amount',
    markAsDone: 'Mark as done',
    annualBonus: 'Target bonus',
    remainingBonus: 'Remaining bonus',
    attachments: 'Attachments',
    comments: 'Comments',
    commentsDisclaimer: 'Please note that comments will not be included in the conclusion PDF.',
    commentsReviewerDisclaimer:
      'These comments will not appear in the conclusion PDF. Please use the Notes area to share any important comments.',
    commentsNote:
      'NB: These comments will not be seen in the Appraisal PDF. Please use the Notes area to share any important comments you would like to keep in the final PDF.',
    userNotFound: 'User not found',
    meetingNotFound: 'Meeting not found',
    globalIdNotFound: 'Global ID not found',
    deleteNotAllowed: 'Cannot delete',
    duplicationAndDismissionNotAllowed: 'Cannot duplicate and dismiss or delete',
    currentObjectiveNotFound: 'Current objective not found',
    duplicateAndDismissNotAllowed: 'Cannot duplicate and dismiss this objective.',
    duplicateAndDeleteNotAllowed: 'Cannot duplicate and delete this objective.',
    formErrors: 'Errors on form',
    targetError: 'Error saving target',
    achievedAmountRequired: 'Required amount or %',
    targetMessage: {
      POL: 'The final out payment of the bonus depends on the overall appraisal result',
    },
    duplicateAndDismissWarning:
      'This monetary objective has an invalid currency ({{objectiveCurrency}}). The currency of the current contract is {{currentContractCurrency}}, therefore it must be duplicated and dismissed in order to be re-alligned.',
    duplicateAndDeleteWarning:
      'This monetary objective has an invalid currency ({{objectiveCurrency}}). The currency of the current contract is {{currentContractCurrency}}, therefore it must be duplicated and deleted in order to be re-alligned.',
    closeNewMonetaryTargetDisclaimer: {
      heading: 'Proceed with payment?',
      body: '<strong>Attention: you have marked this {{year}} target as <i>DONE</i>. If you proceed, the payment will be processed once the appraisal will be confirmed by you.</strong>\n\nIf you don’t want to continue with the payment, click <strong>Cancel</strong> and remove the “<strong>Mark as done</strong>” flag — this will allow you to manage the payment during a future appraisal meeting.\n\nIf you wish to process the payment upon meeting confirmation, click <strong>Proceed</strong>.\n<strong>Please note</strong> that the payment will still be processed even if the employee disputes the meeting.',
    },
    notifications: {
      operations: {
        created: 'created',
        edited: 'edited',
        suggested: 'suggested',
        deleted: 'deleted',
        duplicatedAndDismissed: 'duplicated and dismissed',
      },
      success: {
        title: 'Success',
        description: '{{type}} successfully {{operation}}.',
      },
    },
    outdatedTargets: {
      title: 'Close outdated targets',
      disclaimer:
        'This section contains targets from previous appraisal seasons that are no longer valid or manageable. These targets are shown for reference purposes only and must be closed in order to proceed with the meeting confirmation.',
      descriptionModal1:
        'You are about to close outdated targets associated with <0>{{employeeFullName}}</0> from previous appraisal seasons. These targets can no longer be managed and they need to be closed in order to proceed with the meeting confirmation.',
      descriptionModal2:
        'Please note that any bonus amount related to monetary targets will not be paid, as these targets are no longer valid.',
      notifications: {
        successTitle: 'Outdated targets closed',
        successDescription: 'The outdated targets have been successfully closed.',
        error: 'Failed to close outdated targets. Please try again.',
      },
    },
  },
  targetTemplateModal: {
    comments: 'Comments',
    newTarget: 'New target template',
    editTarget: 'Edit target template',
    deleteError: 'Error deleting target',
    tasks: 'Tasks',
    taskPlaceholder: 'Create new task',
    title: 'Title',
    titlePlaceholder: 'Insert target title',
    totalOfCharInTasks: 'Total of characters for all tasks',
    formErrors: 'Errors on form',
    targetError: 'Error saving target',
    notifications: {
      create: {
        success: {
          title: 'Success',
          description: 'Target Template successfully created.',
        },
      },
      update: {
        success: {
          title: 'Success',
          description: 'Target Template successfully updated.',
        },
      },
    },
  },
  cancelTargetTemplateModal: {
    title: 'Are you sure you want to delete this target template?',
    description: "Once you delete the template it won't be visible anymore for all editors.",
  },
  inviteModal: {
    overlapMessage_1: 'You already have a meeting on this date and time.',
    overlapMessage_2: 'You can proceed with invitation anyway and reschedule one of them later.',
  },
  settingsModal: {
    title: 'Settings',
    description:
      'Timezone, date and time format, and decimal notation are currently set on your legal entity. Select different values to change them.',
    timezoneAndLocale: 'Timezone and locale',
    timezone: {
      label: 'Timezone',
      timezoneOffset: 'UTC{{offset}}',
      offsetsSeparator: ' / ',
      suggestedTimezoneButton: `Set suggested timezone: {{timezone}}`,
    },
    locale: 'Locale',
    preview: 'Preview',
    timeFormat: 'Time',
    dateFormat: 'Date',
    decimalNotation: 'Decimal notation',
    currencyNotation: 'Currency notation',
    settingsError: 'Error occured while trying to save settings',
    nameDisplayPreference: {
      title: 'Name display preferences',
      description: 'Names in all table will be displayed according to the chosen option.',
    },
  },
  rescheduleModal: {
    notifications: {
      reschedule: {
        successTitle: 'Meeting rescheduled!',
        successDescription: 'Your attendees will receive an email with the new proposal.',
        errorTitle: 'Meeting rescheduling failed!',
        errorDescription: 'Something went wrong while trying to reschedule the meeting.',
      },
    },
  },
  onboardingModal: {
    title: 'Welcome to MEPLY',
  },
  currencyConversion: {
    tooltips: {
      tableWarning: "This target has a currency which is different from the one of the employee's current contract",
      employeeTableWarning: 'This target has a currency which is different from the one of your current contract',
      tableConversionWarning:
        "This target has a currency which is different from the one of the employee's current contract, but no conversion rate was found from currency {{startingCurrency}} to {{targetCurrency}}.",
      employeeTableConversionWarning:
        'This target has a currency which is different from the one of your current contract, but no conversion rate was found from currency {{startingCurrency}} to {{targetCurrency}}.',
      objectiveCurrency: 'Currency of the objective',
      currentContractCurrency: 'Currency of the current contract',
      conversionError: 'It was not possible to retrieve the conversion rate from {{startingCurrency}} to {{targetCurrency}}',
      moreThanOneCurrency: 'Cannot calculate the total amount because there is more than one currency among payments',
      invalidCurrency: 'Currency does not match the one of the current contract',
      unknownConversionRate:
        'Currency for current contract is {{currentContractCurrency}}. No conversion rate found for these currencies: {{unknownCurrencies}}',
    },
  },
}

export { i18nTranslationsWebEn }
